const groupData = [
  {
    "value": "01",
    "label": "01 综合、术语学、标准化、文献",
    "children": [
      {
        "value": "01.020",
        "label": "01.020 术语学(原则和协调配合)",

      },
      {
        "value": "01.040",
        "label": "01.040 词汇",
        "children": [
          {
            "value": "01.040.01",
            "label": "01.040.01 综合、术语学、标准化、文献 (词汇)",

          },
          {
            "value": "01.040.03",
            "label": "01.040.03 社会学、服务、公司(企业)的组织和管理、行政、运输 (词汇)",

          },
          {
            "value": "01.040.07",
            "label": "01.040.07 数学、自然科学 (词汇)",

          },
          {
            "value": "01.040.11",
            "label": "01.040.11 医药卫生技术(词汇)",

          },
          {
            "value": "01.040.13",
            "label": "01.040.13 环保、保健和安全 (词汇)",

          },
          {
            "value": "01.040.17",
            "label": "01.040.17 计量学和测量、物理现象 (词汇)",

          },
          {
            "value": "01.040.19",
            "label": "01.040.19 试验 (词汇)",

          },
          {
            "value": "01.040.21",
            "label": "01.040.21 机械系统和通用件 (词汇)",

          },
          {
            "value": "01.040.23",
            "label": "01.040.23 流体系统和通用件 (词汇)",

          },
          {
            "value": "01.040.25",
            "label": "01.040.25 机械制造 (词汇)",

          },
          {
            "value": "01.040.27",
            "label": "01.040.27 能源和热传导工程 (词汇)",

          },
          {
            "value": "01.040.29",
            "label": "01.040.29 电气工程 (词汇)",

          },
          {
            "value": "01.040.31",
            "label": "01.040.31 电子学 (词汇)",

          },
          {
            "value": "01.040.33",
            "label": "01.040.33 电信、音频和视频技术 (词汇)",

          },
          {
            "value": "01.040.35",
            "label": "01.040.35 信息技术、办公机械设备 (词汇)",

          },
          {
            "value": "01.040.37",
            "label": "01.040.37 成像技术 (词汇)",

          },
          {
            "value": "01.040.39",
            "label": "01.040.39 精密机械、珠宝 (词汇)",

          },
          {
            "value": "01.040.43",
            "label": "01.040.43 道路车辆工程 (词汇)",

          },
          {
            "value": "01.040.45",
            "label": "01.040.45 铁路工程 (词汇)",

          },
          {
            "value": "01.040.47",
            "label": "01.040.47 造船和海上构筑物 (词汇)",

          },
          {
            "value": "01.040.49",
            "label": "01.040.49 航空器和航天器技术 (词汇)",

          },
          {
            "value": "01.040.53",
            "label": "01.040.53 材料储运设备 (词汇)",

          },
          {
            "value": "01.040.55",
            "label": "01.040.55 货物的包装和调运 (词汇)",

          },
          {
            "value": "01.040.59",
            "label": "01.040.59 纺织和皮革技术 (词汇)",

          },
          {
            "value": "01.040.61",
            "label": "01.040.61 服装工业 (词汇)",

          },
          {
            "value": "01.040.65",
            "label": "01.040.65 农业 (词汇)",

          },
          {
            "value": "01.040.67",
            "label": "01.040.67 食品技术 (词汇)",

          },
          {
            "value": "01.040.71",
            "label": "01.040.71 化工技术 (词汇)",

          },
          {
            "value": "01.040.73",
            "label": "01.040.73 采矿和矿产品 (词汇)",

          },
          {
            "value": "01.040.75",
            "label": "01.040.75 石油及相关技术 (词汇)",

          },
          {
            "value": "01.040.77",
            "label": "01.040.77 冶金 (词汇)",

          },
          {
            "value": "01.040.79",
            "label": "01.040.79 木材加工(词汇)",

          },
          {
            "value": "01.040.81",
            "label": "01.040.81 玻璃和陶瓷工业 (词汇)",

          },
          {
            "value": "01.040.83",
            "label": "01.040.83 橡胶和塑料工业 (词汇)",

          },
          {
            "value": "01.040.85",
            "label": "01.040.85 造纸技术 (词汇)",

          },
          {
            "value": "01.040.87",
            "label": "01.040.87 涂料和颜料工业 (词汇)",

          },
          {
            "value": "01.040.91",
            "label": "01.040.91 建筑材料和建筑物 (词汇)",

          },
          {
            "value": "01.040.93",
            "label": "01.040.93 土木工程 (词汇)",

          },
          {
            "value": "01.040.95",
            "label": "01.040.95 军事工程 (词汇)",

          },
          {
            "value": "01.040.97",
            "label": "01.040.97 家用和商用设备、文娱 、体育(词汇)",

          }
        ]
      },
      {
        "value": "01.060",
        "label": "01.060 量和单位",

      },
      {
        "value": "01.070",
        "label": "01.070 颜色编码",

      },
      {
        "value": "01.075",
        "label": "01.075 字符符号",

      },
      {
        "value": "01.080",
        "label": "01.080 图形符号",
        "children": [
          {
            "value": "01.080.01",
            "label": "01.080.01 图形符号综合",

          },
          {
            "value": "01.080.10",
            "label": "01.080.10 公共信息符号",

          },
          {
            "value": "01.080.20",
            "label": "01.080.20 特定设备用图形符号",

          },
          {
            "value": "01.080.30",
            "label": "01.080.30 机械工程和建筑制图、图表、设计图、地图和相关的技术产品文件用图形符号",

          },
          {
            "value": "01.080.40",
            "label": "01.080.40 电气工程和电子工程制图、示意图、图表和相关技术产品文件用图形符号",

          },
          {
            "value": "01.080.50",
            "label": "01.080.50 信息技术和电信技术制图和相关技术产品文件用图形符号",

          },
          {
            "value": "01.080.99",
            "label": "01.080.99 其他图形符号",

          }
        ]
      },
      {
        "value": "01.100",
        "label": "01.100 技术制图",
        "children": [
          {
            "value": "01.100.01",
            "label": "01.100.01 技术制图综合",

          },
          {
            "value": "01.100.20",
            "label": "01.100.20 机械工程制图",

          },
          {
            "value": "01.100.25",
            "label": "01.100.25 电气和电子工程制图",

          },
          {
            "value": "01.100.27",
            "label": "01.100.27 信息技术和电信领域用技术制图",

          },
          {
            "value": "01.100.30",
            "label": "01.100.30 工程建设制图",

          },
          {
            "value": "01.100.40",
            "label": "01.100.40 制图设备",

          },
          {
            "value": "01.100.99",
            "label": "01.100.99 其他制图标准",

          }
        ]
      },
      {
        "value": "01.110",
        "label": "01.110 技术产品文件",

      },
      {
        "value": "01.120",
        "label": "01.120 标准化总则",

      },
      {
        "value": "01.140",
        "label": "01.140 信息学、出版",
        "children": [
          {
            "value": "01.140.10",
            "label": "01.140.10 文字字体和文字转写",

          },
          {
            "value": "01.140.20",
            "label": "01.140.20 信息学",

          },
          {
            "value": "01.140.30",
            "label": "01.140.30 行政管理、商业和工业文件",

          },
          {
            "value": "01.140.40",
            "label": "01.140.40 出版",

          }
        ]
      }
    ]
  },
  {
    "value": "03",
    "label": "03 社会学、 服务、公司(企业)的组织和管理、行政、运输",
    "children": [
      {
        "value": "03.020",
        "label": "03.020 社会学、人口统计学",

      },
      {
        "value": "03.040",
        "label": "03.040 劳动、就业",

      },
      {
        "value": "03.060",
        "label": "03.060 金融、银行、货币体系、保险",

      },
      {
        "value": "03.080",
        "label": "03.080 服务",
        "children": [
          {
            "value": "03.080.01",
            "label": "03.080.01 服务综合",

          },
          {
            "value": "03.080.10",
            "label": "03.080.10 工业服务",

          },
          {
            "value": "03.080.20",
            "label": "03.080.20 公司(企业)的服务",

          },
          {
            "value": "03.080.30",
            "label": "03.080.30 消费者服务",

          },
          {
            "value": "03.080.99",
            "label": "03.080.99 其他服务",

          }
        ]
      },
      {
        "value": "03.100",
        "label": "03.100 公司(企业)的组织和管理",
        "children": [
          {
            "value": "03.100.01",
            "label": "03.100.01 公司(企业)的组织和管理综合",

          },
          {
            "value": "03.100.10",
            "label": "03.100.10 订购、收购、仓库管理",

          },
          {
            "value": "03.100.20",
            "label": "03.100.20 贸易、商业活动、市场营销",

          },
          {
            "value": "03.100.30",
            "label": "03.100.30 劳动资源管理",

          },
          {
            "value": "03.100.40",
            "label": "03.100.40 研究和开发",

          },
          {
            "value": "03.100.50",
            "label": "03.100.50 生产、生产管理",

          },
          {
            "value": "03.100.60",
            "label": "03.100.60 会计",

          },
          {
            "value": "03.100.99",
            "label": "03.100.99 有关公司(企业)组织管理的其他标准",

          }
        ]
      },
      {
        "value": "03.120",
        "label": "03.120 质量",
        "children": [
          {
            "value": "03.120.01",
            "label": "03.120.01 质量综合",

          },
          {
            "value": "03.120.10",
            "label": "03.120.10 质量管理和质量保证",

          },
          {
            "value": "03.120.20",
            "label": "03.120.20 产品认证和机构认证、合格评定",

          },
          {
            "value": "03.120.30",
            "label": "03.120.30 统计方法的应用",

          },
          {
            "value": "03.120.99",
            "label": "03.120.99 有关质量的其他标准",

          }
        ]
      },
      {
        "value": "03.140",
        "label": "03.140 专利、知识产权",

      },
      {
        "value": "03.160",
        "label": "03.160 法律、行政管理",

      },
      {
        "value": "03.180",
        "label": "03.180 教育",

      },
      {
        "value": "03.200",
        "label": "03.200 娱乐、旅游",

      },
      {
        "value": "03.220",
        "label": "03.220 运输",
        "children": [
          {
            "value": "03.220.01",
            "label": "03.220.01 运输综合",

          },
          {
            "value": "03.220.20",
            "label": "03.220.20 道路运输",

          },
          {
            "value": "03.220.30",
            "label": "03.220.30 铁路运输",

          },
          {
            "value": "03.220.40",
            "label": "03.220.40 水路运输",

          },
          {
            "value": "03.220.50",
            "label": "03.220.50 航空运输",

          },
          {
            "value": "03.220.99",
            "label": "03.220.99 其他运输形式",

          }
        ]
      },
      {
        "value": "03.240",
        "label": "03.240 邮政服务",

      }
    ]
  },
  {
    "value": "07",
    "label": "07 数学、自然科学",
    "children": [
      {
        "value": "07.020",
        "label": "07.020 数学",

      },
      {
        "value": "07.030",
        "label": "07.030 物理学、化学",

      },
      {
        "value": "07.040",
        "label": "07.040 天文学、大地测量学、地理学",

      },
      {
        "value": "07.060",
        "label": "07.060 地质学、气象学、水文学",

      },
      {
        "value": "07.080",
        "label": "07.080 生物学、植物学、动物学",

      },
      {
        "value": "07.100",
        "label": "07.100 微生物学",
        "children": [
          {
            "value": "07.100.01",
            "label": "07.100.01 微生物学综合",

          },
          {
            "value": "07.100.10",
            "label": "07.100.10 医学微生物学",

          },
          {
            "value": "07.100.20",
            "label": "07.100.20 水的微生物学",

          },
          {
            "value": "07.100.30",
            "label": "07.100.30 食品微生物学",

          },
          {
            "value": "07.100.99",
            "label": "07.100.99 有关微生物学的其他标准",

          },
          {
            "value": "07.100.40",
            "label": "07.100.40 美容化妆品微生物学",

          }
        ]
      },
      {
        "value": "07.120",
        "label": "07.120 纳米技术",

      },
      {
        "value": "07.140",
        "label": "07.140 法医学",

      }
    ]
  },
  {
    "value": "11",
    "label": "11 医药卫生技术",
    "children": [
      {
        "value": "11.020",
        "label": "11.020 医学科学和保健装置综合",

      },
      {
        "value": "11.040",
        "label": "11.040 医疗设备",
        "children": [
          {
            "value": "11.040.01",
            "label": "11.040.01 医疗设备综合",

          },
          {
            "value": "11.040.10",
            "label": "11.040.10 麻醉、呼吸和复苏设备",

          },
          {
            "value": "11.040.20",
            "label": "11.040.20 输血、输液和注射设备",

          },
          {
            "value": "11.040.30",
            "label": "11.040.30 外科器械和材料",

          },
          {
            "value": "11.040.40",
            "label": "11.040.40 外科植入物、假体和矫形",

          },
          {
            "value": "11.040.50",
            "label": "11.040.50 射线照相设备",

          },
          {
            "value": "11.040.55",
            "label": "11.040.55 诊断设备",

          },
          {
            "value": "11.040.60",
            "label": "11.040.60 治疗设备",

          },
          {
            "value": "11.040.70",
            "label": "11.040.70 眼科设备",

          },
          {
            "value": "11.040.99",
            "label": "11.040.99 其他医疗设备",

          }
        ]
      },
      {
        "value": "11.060",
        "label": "11.060 牙科",
        "children": [
          {
            "value": "11.060.01",
            "label": "11.060.01 牙科综合",

          },
          {
            "value": "11.060.10",
            "label": "11.060.10 牙科材料",

          },
          {
            "value": "11.060.15",
            "label": "11.060.15 牙科植入物",

          },
          {
            "value": "11.060.20",
            "label": "11.060.20 牙科设备",

          },
          {
            "value": "11.060.25",
            "label": "11.060.25 牙科仪器",

          }
        ]
      },
      {
        "value": "11.080",
        "label": "11.080 消毒和灭菌",
        "children": [
          {
            "value": "11.080.01",
            "label": "11.080.01 消毒和灭菌综合",

          },
          {
            "value": "11.080.10",
            "label": "11.080.10 消毒设备",

          },
          {
            "value": "11.080.20",
            "label": "11.080.20 消毒剂和防腐剂",

          },
          {
            "value": "11.080.30",
            "label": "11.080.30 消毒封装",

          },
          {
            "value": "11.080.99",
            "label": "11.080.99 有关消毒和灭菌的其他标准",

          }
        ]
      },
      {
        "value": "11.100",
        "label": "11.100 实验室医学",

      },
      {
        "value": "11.120",
        "label": "11.120 制药学",
        "children": [
          {
            "value": "11.120.01",
            "label": "11.120.01 制药学综合",

          },
          {
            "value": "11.120.10",
            "label": "11.120.10 药物",

          },
          {
            "value": "11.120.20",
            "label": "11.120.20 医用材料",

          },
          {
            "value": "11.120.99",
            "label": "11.120.99 有关制药学的其他标准",

          }
        ]
      },
      {
        "value": "11.140",
        "label": "11.140 医院设备",

      },
      {
        "value": "11.160",
        "label": "11.160 急救",

      },
      {
        "value": "11.180",
        "label": "11.180 残障人员用设备",
        "children": [
          {
            "value": "11.180.01",
            "label": "11.180.01 残障人员用设备综合",

          },
          {
            "value": "11.180.10",
            "label": "11.180.10 运动用设备及其配合性",

          },
          {
            "value": "11.180.20",
            "label": "11.180.20 造口术和失禁用设备",

          },
          {
            "value": "11.180.30",
            "label": "11.180.30 阅读用设备及其配合性",

          },
          {
            "value": "11.180.40",
            "label": "11.180.40 饮水和进食用设备",

          },
          {
            "value": "11.180.99",
            "label": "11.180.99 有关残障人员用设备的其它标准",

          }
        ]
      },
      {
        "value": "11.200",
        "label": "11.200 人口控制、避孕器具",

      },
      {
        "value": "11.220",
        "label": "11.220 兽医学",

      }
    ]
  },
  {
    "value": "13",
    "label": "13 环保、保健和安全",
    "children": [
      {
        "value": "13.020",
        "label": "13.020 环境保护",
        "children": [
          {
            "value": "13.020.01",
            "label": "13.020.01 环境和环境保护综合",

          },
          {
            "value": "13.020.10",
            "label": "13.020.10 环境管理",

          },
          {
            "value": "13.020.20",
            "label": "13.020.20 环境经济",

          },
          {
            "value": "13.020.30",
            "label": "13.020.30 环境影响评定",

          },
          {
            "value": "13.020.40",
            "label": "13.020.40 污染、污染控制和保护",

          },
          {
            "value": "13.020.50",
            "label": "13.020.50 环境分类",

          },
          {
            "value": "13.020.60",
            "label": "13.020.60 产品寿命周期",

          },
          {
            "value": "13.020.70",
            "label": "13.020.70 环境规划",

          },
          {
            "value": "13.020.99",
            "label": "13.020.99 有关环境保护的其他标准",

          }
        ]
      },
      {
        "value": "13.030",
        "label": "13.030 废物",
        "children": [
          {
            "value": "13.030.01",
            "label": "13.030.01 废物综合",

          },
          {
            "value": "13.030.10",
            "label": "13.030.10 固态废物",

          },
          {
            "value": "13.030.20",
            "label": "13.030.20 液态废物、淤泥",

          },
          {
            "value": "13.030.30",
            "label": "13.030.30 特殊废物",

          },
          {
            "value": "13.030.40",
            "label": "13.030.40 废物处置和处理设备和装置",

          },
          {
            "value": "13.030.50",
            "label": "13.030.50 回收",

          },
          {
            "value": "13.030.99",
            "label": "13.030.99 有关废物的其他标准",

          }
        ]
      },
      {
        "value": "13.040",
        "label": "13.040 空气质量",
        "children": [
          {
            "value": "13.040.01",
            "label": "13.040.01 空气质量综合",

          },
          {
            "value": "13.040.20",
            "label": "13.040.20 环境空气",

          },
          {
            "value": "13.040.30",
            "label": "13.040.30 工作场所空气",

          },
          {
            "value": "13.040.35",
            "label": "13.040.35 清洁室（无菌室）及相关受控环境",

          },
          {
            "value": "13.040.40",
            "label": "13.040.40 固定源排放限值",

          },
          {
            "value": "13.040.50",
            "label": "13.040.50 移动源排放限值",

          },
          {
            "value": "13.040.99",
            "label": "13.040.99 有关空气质量的其他标准",

          }
        ]
      },
      {
        "value": "13.060",
        "label": "13.060 水质",
        "children": [
          {
            "value": "13.060.01",
            "label": "13.060.01 水质综合",

          },
          {
            "value": "13.060.10",
            "label": "13.060.10 天然水资源",

          },
          {
            "value": "13.060.20",
            "label": "13.060.20 饮用水",

          },
          {
            "value": "13.060.25",
            "label": "13.060.25 工业用水",

          },
          {
            "value": "13.060.30",
            "label": "13.060.30 污水",

          },
          {
            "value": "13.060.45",
            "label": "13.060.45 水检验综合",

          },
          {
            "value": "13.060.50",
            "label": "13.060.50 水的化学物质检验",

          },
          {
            "value": "13.060.60",
            "label": "13.060.60 水的物理特性检验",

          },
          {
            "value": "13.060.70",
            "label": "13.060.70 水的生物学特性的检验",

          },
          {
            "value": "13.060.99",
            "label": "13.060.99 有关水质的其他标准",

          }
        ]
      },
      {
        "value": "13.080",
        "label": "13.080 土质、土壤学",
        "children": [
          {
            "value": "13.080.01",
            "label": "13.080.01 土质和土壤学综合",

          },
          {
            "value": "13.080.05",
            "label": "13.080.05 土壤检验综合",

          },
          {
            "value": "13.080.10",
            "label": "13.080.10 土壤的化学特性",

          },
          {
            "value": "13.080.20",
            "label": "13.080.20 土壤的物理特性",

          },
          {
            "value": "13.080.30",
            "label": "13.080.30 土壤的生物特性",

          },
          {
            "value": "13.080.40",
            "label": "13.080.40 土壤的水文特性",

          },
          {
            "value": "13.080.99",
            "label": "13.080.99 有关土质的其他标准",

          }
        ]
      },
      {
        "value": "13.100",
        "label": "13.100 职业安全、工业卫生",

      },
      {
        "value": "13.110",
        "label": "13.110 机械安全",

      },
      {
        "value": "13.120",
        "label": "13.120 家用品安全",

      },
      {
        "value": "13.140",
        "label": "13.140 噪声(与人有关的)",

      },
      {
        "value": "13.160",
        "label": "13.160 振动和冲击(与人有关的)",

      },
      {
        "value": "13.180",
        "label": "13.180 人类工效学",

      },
      {
        "value": "13.200",
        "label": "13.200 事故和灾害控制",

      },
      {
        "value": "13.220",
        "label": "13.220 消防",
        "children": [
          {
            "value": "13.220.01",
            "label": "13.220.01 消防综合",

          },
          {
            "value": "13.220.10",
            "label": "13.220.10 灭火",

          },
          {
            "value": "13.220.20",
            "label": "13.220.20 防火",

          },
          {
            "value": "13.220.40",
            "label": "13.220.40 材料和制品的可燃性和燃烧性能",

          },
          {
            "value": "13.220.50",
            "label": "13.220.50 建筑材料和构件的阻燃性",

          },
          {
            "value": "13.220.99",
            "label": "13.220.99 有关消防的其他标准",

          }
        ]
      },
      {
        "value": "13.230",
        "label": "13.230 防爆",

      },
      {
        "value": "13.240",
        "label": "13.240 过压保护",

      },
      {
        "value": "13.260",
        "label": "13.260 电击防护",

      },
      {
        "value": "13.280",
        "label": "13.280 辐射防护",

      },
      {
        "value": "13.300",
        "label": "13.300 危险品防护",

      },
      {
        "value": "13.310",
        "label": "13.310 犯罪行为防范",

      },
      {
        "value": "13.320",
        "label": "13.320 报警和警告系统",

      },
      {
        "value": "13.340",
        "label": "13.340 防护设备",
        "children": [
          {
            "value": "13.340.01",
            "label": "13.340.01 防护设备综合",

          },
          {
            "value": "13.340.10",
            "label": "13.340.10 防护服装",

          },
          {
            "value": "13.340.20",
            "label": "13.340.20 头部防护设备",

          },
          {
            "value": "13.340.30",
            "label": "13.340.30 呼吸保护装置",

          },
          {
            "value": "13.340.40",
            "label": "13.340.40 防护手套",

          },
          {
            "value": "13.340.50",
            "label": "13.340.50 防护鞋",

          },
          {
            "value": "13.340.99",
            "label": "13.340.99 其他防护设备",

          }
        ]
      }
    ]
  },
  {
    "value": "17",
    "label": "17 计量学和测量、物理现象",
    "children": [
      {
        "value": "17.020",
        "label": "17.020 计量学和测量综合",

      },
      {
        "value": "17.040",
        "label": "17.040 长度和角度测量",
        "children": [
          {
            "value": "17.040.01",
            "label": "17.040.01 长度和角度测量综合",

          },
          {
            "value": "17.040.10",
            "label": "17.040.10 极限和配合",

          },
          {
            "value": "17.040.20",
            "label": "17.040.20 表面特征",

          },
          {
            "value": "17.040.30",
            "label": "17.040.30 测量仪器仪表",

          },
          {
            "value": "17.040.99",
            "label": "17.040.99 有关长度和角度测量的其他标准",

          }
        ]
      },
      {
        "value": "17.060",
        "label": "17.060 体积、质量、密度和粘度的测量",

      },
      {
        "value": "17.080",
        "label": "17.080 时间、速度、加速度、角速度的测量",

      },
      {
        "value": "17.100",
        "label": "17.100 力、重力和压力的测量",

      },
      {
        "value": "17.120",
        "label": "17.120 流体流量的测量",
        "children": [
          {
            "value": "17.120.01",
            "label": "17.120.01 流体流量的测量综合",

          },
          {
            "value": "17.120.10",
            "label": "17.120.10 封闭管道中流量的测量",

          },
          {
            "value": "17.120.20",
            "label": "17.120.20 明渠中流量的测量",

          }
        ]
      },
      {
        "value": "17.140",
        "label": "17.140 声学和声学测量",
        "children": [
          {
            "value": "17.140.01",
            "label": "17.140.01 声学测量和噪声抑制综合",

          },
          {
            "value": "17.140.20",
            "label": "17.140.20 机器和设备的噪声",

          },
          {
            "value": "17.140.30",
            "label": "17.140.30 运输工具的噪声",

          },
          {
            "value": "17.140.50",
            "label": "17.140.50 电声学",

          },
          {
            "value": "17.140.99",
            "label": "17.140.99 有关声学的其他标准",

          }
        ]
      },
      {
        "value": "17.160",
        "label": "17.160 振动、冲击和振动测量",

      },
      {
        "value": "17.180",
        "label": "17.180 光学和光学测量",
        "children": [
          {
            "value": "17.180.01",
            "label": "17.180.01 光学和光学测量综合",

          },
          {
            "value": "17.180.20",
            "label": "17.180.20 颜色和光的测量",

          },
          {
            "value": "17.180.30",
            "label": "17.180.30 光学测量仪器",

          },
          {
            "value": "17.180.99",
            "label": "17.180.99 有关光学和光学测量的其他标准",

          }
        ]
      },
      {
        "value": "17.200",
        "label": "17.200 热力学和温度测量",
        "children": [
          {
            "value": "17.200.01",
            "label": "17.200.01 热力学综合",

          },
          {
            "value": "17.200.10",
            "label": "17.200.10 热、量热学",

          },
          {
            "value": "17.200.20",
            "label": "17.200.20 温度测量仪器仪表",

          },
          {
            "value": "17.200.99",
            "label": "17.200.99 有关热力学的其他标准",

          }
        ]
      },
      {
        "value": "17.220",
        "label": "17.220 电学、磁学、电和磁的测量",
        "children": [
          {
            "value": "17.220.01",
            "label": "17.220.01 电学、磁学综合",

          },
          {
            "value": "17.220.20",
            "label": "17.220.20 电和磁量值的测量",

          },
          {
            "value": "17.220.99",
            "label": "17.220.99 有关电学和磁学的其他标准",

          }
        ]
      },
      {
        "value": "17.240",
        "label": "17.240 辐射测量",

      }
    ]
  },
  {
    "value": "19",
    "label": "19 试验",
    "children": [
      {
        "value": "19.020",
        "label": "19.020 试验条件和规程综合",

      },
      {
        "value": "19.040",
        "label": "19.040 环境试验",

      },
      {
        "value": "19.060",
        "label": "19.060 机械试验",

      },
      {
        "value": "19.080",
        "label": "19.080 电工和电子试验",

      },
      {
        "value": "19.100",
        "label": "19.100 无损检测",

      },
      {
        "value": "19.120",
        "label": "19.120 粒度分析、筛分",

      }
    ]
  },
  {
    "value": "21",
    "label": "21 机械系统和通用件",
    "children": [
      {
        "value": "21.020",
        "label": "21.020 机器、装置、设备的特性和设计",

      },
      {
        "value": "21.040",
        "label": "21.040 螺纹",
        "children": [
          {
            "value": "21.040.01",
            "label": "21.040.01 螺纹综合",

          },
          {
            "value": "21.040.10",
            "label": "21.040.10 公制螺纹",

          },
          {
            "value": "21.040.20",
            "label": "21.040.20 英制螺纹",

          },
          {
            "value": "21.040.30",
            "label": "21.040.30 特殊螺纹",

          }
        ]
      },
      {
        "value": "21.060",
        "label": "21.060 紧固件",
        "children": [
          {
            "value": "21.060.01",
            "label": "21.060.01 紧固件综合",

          },
          {
            "value": "21.060.10",
            "label": "21.060.10 螺栓、螺钉、螺柱",

          },
          {
            "value": "21.060.20",
            "label": "21.060.20 螺母",

          },
          {
            "value": "21.060.30",
            "label": "21.060.30 垫圈、锁紧件",

          },
          {
            "value": "21.060.40",
            "label": "21.060.40 铆钉",

          },
          {
            "value": "21.060.50",
            "label": "21.060.50 销、钉",

          },
          {
            "value": "21.060.60",
            "label": "21.060.60 环、套管、管接头、承插",

          },
          {
            "value": "21.060.70",
            "label": "21.060.70 卡箍和U形环",

          },
          {
            "value": "21.060.99",
            "label": "21.060.99 其他紧固件",

          }
        ]
      },
      {
        "value": "21.080",
        "label": "21.080 铰链、孔眼和其他关节连接件",

      },
      {
        "value": "21.100",
        "label": "21.100 轴承",
        "children": [
          {
            "value": "21.100.01",
            "label": "21.100.01 轴承综合",

          },
          {
            "value": "21.100.10",
            "label": "21.100.10 滑动轴承",

          },
          {
            "value": "21.100.20",
            "label": "21.100.20 滚动轴承",

          }
        ]
      },
      {
        "value": "21.120",
        "label": "21.120 轴和联轴器",
        "children": [
          {
            "value": "21.120.01",
            "label": "21.120.01 轴和联轴器综合",

          },
          {
            "value": "21.120.10",
            "label": "21.120.10 轴",

          },
          {
            "value": "21.120.20",
            "label": "21.120.20 联轴器、离合器、摩擦器",

          },
          {
            "value": "21.120.30",
            "label": "21.120.30 键和键槽、花键",

          },
          {
            "value": "21.120.40",
            "label": "21.120.40 平衡和平衡机",

          },
          {
            "value": "21.120.99",
            "label": "21.120.99 有关轴和联轴器的其他标准",

          }
        ]
      },
      {
        "value": "21.140",
        "label": "21.140 密封件、密封装置",

      },
      {
        "value": "21.160",
        "label": "21.160 弹簧",

      },
      {
        "value": "21.180",
        "label": "21.180 机箱、外壳、其他机器部件",

      },
      {
        "value": "21.200",
        "label": "21.200 齿轮及齿轮传动",

      },
      {
        "value": "21.220",
        "label": "21.220 挠性传动和传送",
        "children": [
          {
            "value": "21.220.01",
            "label": "21.220.01 挠性传动和传送综合",

          },
          {
            "value": "21.220.10",
            "label": "21.220.10 带传动及其零件",

          },
          {
            "value": "21.220.20",
            "label": "21.220.20 缆索或绳索传动及其零件",

          },
          {
            "value": "21.220.30",
            "label": "21.220.30 链传动及其零件",

          },
          {
            "value": "21.220.99",
            "label": "21.220.99 其它挠性传动和传送",

          }
        ]
      },
      {
        "value": "21.240",
        "label": "21.240 旋转-往复式机构及其部件",

      },
      {
        "value": "21.260",
        "label": "21.260 润滑系统",

      }
    ]
  },
  {
    "value": "21-010",
    "label": "21-010 机械系统和通用件综合",

  },
  {
    "value": "23",
    "label": "23 流体系统和通用件",
    "children": [
      {
        "value": "23.020",
        "label": "23.020 流体存储装置",
        "children": [
          {
            "value": "23.020.01",
            "label": "23.020.01 流体存储装置综合",

          },
          {
            "value": "23.020.10",
            "label": "23.020.10 固定容器和罐",

          },
          {
            "value": "23.020.20",
            "label": "23.020.20 车载槽罐和容器",

          },
          {
            "value": "23.020.30",
            "label": "23.020.30 压力容器、气瓶",

          },
          {
            "value": "23.020.40",
            "label": "23.020.40 低温容器",

          },
          {
            "value": "23.020.99",
            "label": "23.020.99 其他流体存储装置",

          }
        ]
      },
      {
        "value": "23.040",
        "label": "23.040 管道部件和管道",
        "children": [
          {
            "value": "23.040.01",
            "label": "23.040.01 管道部件和管道综合",

          },
          {
            "value": "23.040.10",
            "label": "23.040.10 铁管和钢管",

          },
          {
            "value": "23.040.15",
            "label": "23.040.15 有色金属管",

          },
          {
            "value": "23.040.20",
            "label": "23.040.20 塑料管",

          },
          {
            "value": "23.040.40",
            "label": "23.040.40 金属配件",

          },
          {
            "value": "23.040.45",
            "label": "23.040.45 塑料配件",

          },
          {
            "value": "23.040.50",
            "label": "23.040.50 其他材料的管和配件",

          },
          {
            "value": "23.040.60",
            "label": "23.040.60 法兰、管接头和连接件",

          },
          {
            "value": "23.040.70",
            "label": "23.040.70 软管和软管组件",

          },
          {
            "value": "23.040.80",
            "label": "23.040.80 管和软管组件的密封件",

          },
          {
            "value": "23.040.99",
            "label": "23.040.99 其他管道部件",

          }
        ]
      },
      {
        "value": "23.060",
        "label": "23.060 阀门",
        "children": [
          {
            "value": "23.060.01",
            "label": "23.060.01 阀门综合",

          },
          {
            "value": "23.060.10",
            "label": "23.060.10 球阀",

          },
          {
            "value": "23.060.20",
            "label": "23.060.20 球闸阀和旋塞阀",

          },
          {
            "value": "23.060.30",
            "label": "23.060.30 闸阀",

          },
          {
            "value": "23.060.40",
            "label": "23.060.40 压力调节器",

          },
          {
            "value": "23.060.50",
            "label": "23.060.50 止回阀",

          },
          {
            "value": "23.060.99",
            "label": "23.060.99 其他阀门",

          }
        ]
      },
      {
        "value": "23.080",
        "label": "23.080 泵",

      },
      {
        "value": "23.100",
        "label": "23.100 流体动力系统",
        "children": [
          {
            "value": "23.100.01",
            "label": "23.100.01 流体动力系统综合",

          },
          {
            "value": "23.100.10",
            "label": "23.100.10 泵和马达",

          },
          {
            "value": "23.100.20",
            "label": "23.100.20 缸",

          },
          {
            "value": "23.100.40",
            "label": "23.100.40 管道和管接头",

          },
          {
            "value": "23.100.50",
            "label": "23.100.50 控制部件",

          },
          {
            "value": "23.100.60",
            "label": "23.100.60 过滤器、密封垫和流体杂质",

          },
          {
            "value": "23.100.99",
            "label": "23.100.99 其他流体动力系统部件",

          }
        ]
      },
      {
        "value": "23.120",
        "label": "23.120 通风机、风扇、空调器",

      },
      {
        "value": "23.140",
        "label": "23.140 压缩机和气动机械",

      },
      {
        "value": "23.160",
        "label": "23.160 真空技术",

      }
    ]
  },
  {
    "value": "23-010",
    "label": "23-010 流体系统和通用件综合",

  },
  {
    "value": "25",
    "label": "25 机械制造",
    "children": [
      {
        "value": "25.020",
        "label": "25.020 制造成型过程",

      },
      {
        "value": "25.040",
        "label": "25.040 工业自动化系统",
        "children": [
          {
            "value": "25.040.01",
            "label": "25.040.01 工业自动化系统综合",

          },
          {
            "value": "25.040.10",
            "label": "25.040.10 机械加工中心",

          },
          {
            "value": "25.040.20",
            "label": "25.040.20 数控机床",

          },
          {
            "value": "25.040.30",
            "label": "25.040.30 工业机器人、机械手",

          },
          {
            "value": "25.040.40",
            "label": "25.040.40 工业过程的测量和控制",

          },
          {
            "value": "25.040.99",
            "label": "25.040.99 其他工业自动化系统",

          }
        ]
      },
      {
        "value": "25.060",
        "label": "25.060 机床装置",
        "children": [
          {
            "value": "25.060.01",
            "label": "25.060.01 机床装置综合",

          },
          {
            "value": "25.060.10",
            "label": "25.060.10 组合单元和其他装置",

          },
          {
            "value": "25.060.20",
            "label": "25.060.20 分度和刀具/工件夹持装置",

          },
          {
            "value": "25.060.99",
            "label": "25.060.99 其他机床装置",

          }
        ]
      },
      {
        "value": "25.080",
        "label": "25.080 机床",
        "children": [
          {
            "value": "25.080.01",
            "label": "25.080.01 机床综合",

          },
          {
            "value": "25.080.10",
            "label": "25.080.10 车床",

          },
          {
            "value": "25.080.20",
            "label": "25.080.20 镗床和铣床",

          },
          {
            "value": "25.080.25",
            "label": "25.080.25 刨床",

          },
          {
            "value": "25.080.30",
            "label": "25.080.30 拉床",

          },
          {
            "value": "25.080.40",
            "label": "25.080.40 钻床",

          },
          {
            "value": "25.080.50",
            "label": "25.080.50 磨床和抛光机",

          },
          {
            "value": "25.080.60",
            "label": "25.080.60 锯床",

          },
          {
            "value": "25.080.99",
            "label": "25.080.99 其他机床",

          }
        ]
      },
      {
        "value": "25.100",
        "label": "25.100 切削工具",
        "children": [
          {
            "value": "25.100.01",
            "label": "25.100.01 切削工具综合",

          },
          {
            "value": "25.100.10",
            "label": "25.100.10 车刀",

          },
          {
            "value": "25.100.20",
            "label": "25.100.20 铣刀",

          },
          {
            "value": "25.100.25",
            "label": "25.100.25 刨床、拉床用刀具",

          },
          {
            "value": "25.100.30",
            "label": "25.100.30 钻头、锪钻、铰刀",

          },
          {
            "value": "25.100.40",
            "label": "25.100.40 锯",

          },
          {
            "value": "25.100.50",
            "label": "25.100.50 丝锥和板牙",

          },
          {
            "value": "25.100.60",
            "label": "25.100.60 锉刀",

          },
          {
            "value": "25.100.70",
            "label": "25.100.70 磨料磨具",

          },
          {
            "value": "25.100.99",
            "label": "25.100.99 其他切削刀具",

          }
        ]
      },
      {
        "value": "25.120",
        "label": "25.120 无屑加工设备",
        "children": [
          {
            "value": "25.120.01",
            "label": "25.120.01 无屑加工设备综合",

          },
          {
            "value": "25.120.10",
            "label": "25.120.10 锻压设备、冲压机、剪切机",

          },
          {
            "value": "25.120.20",
            "label": "25.120.20 轧制、挤压和拉制设备",

          },
          {
            "value": "25.120.30",
            "label": "25.120.30 模制设备和铸造设备",

          },
          {
            "value": "25.120.40",
            "label": "25.120.40 电化学加工机床",

          },
          {
            "value": "25.120.99",
            "label": "25.120.99 其他无屑加工设备",

          }
        ]
      },
      {
        "value": "25.140",
        "label": "25.140 手持工具",
        "children": [
          {
            "value": "25.140.01",
            "label": "25.140.01 手持工具综合",

          },
          {
            "value": "25.140.10",
            "label": "25.140.10 气动工具",

          },
          {
            "value": "25.140.20",
            "label": "25.140.20 电动工具",

          },
          {
            "value": "25.140.30",
            "label": "25.140.30 手工工具",

          },
          {
            "value": "25.140.99",
            "label": "25.140.99 其他手持工具",

          }
        ]
      },
      {
        "value": "25.160",
        "label": "25.160 焊接、钎焊和低温焊",
        "children": [
          {
            "value": "25.160.01",
            "label": "25.160.01 焊接、钎焊和低温焊综合",

          },
          {
            "value": "25.160.10",
            "label": "25.160.10 焊接工艺",

          },
          {
            "value": "25.160.20",
            "label": "25.160.20 焊接消耗品",

          },
          {
            "value": "25.160.30",
            "label": "25.160.30 焊接设备",

          },
          {
            "value": "25.160.40",
            "label": "25.160.40 焊接接头",

          },
          {
            "value": "25.160.50",
            "label": "25.160.50 钎焊和低温焊",

          }
        ]
      },
      {
        "value": "25.180",
        "label": "25.180 工业炉",
        "children": [
          {
            "value": "25.180.01",
            "label": "25.180.01 工业炉综合",

          },
          {
            "value": "25.180.10",
            "label": "25.180.10 电炉",

          },
          {
            "value": "25.180.20",
            "label": "25.180.20 燃油炉",

          }
        ]
      },
      {
        "value": "25.200",
        "label": "25.200 热处理",

      },
      {
        "value": "25.220",
        "label": "25.220 表面处理和镀涂",
        "children": [
          {
            "value": "25.220.01",
            "label": "25.220.01 表面处理和镀涂综合",

          },
          {
            "value": "25.220.10",
            "label": "25.220.10 表面预处理",

          },
          {
            "value": "25.220.20",
            "label": "25.220.20 表面处理",

          },
          {
            "value": "25.220.40",
            "label": "25.220.40 金属镀层",

          },
          {
            "value": "25.220.50",
            "label": "25.220.50 搪瓷",

          },
          {
            "value": "25.220.60",
            "label": "25.220.60 有机涂层",

          },
          {
            "value": "25.220.99",
            "label": "25.220.99 其他处理和镀涂",

          }
        ]
      },
      {
        "value": "25.220-70",
        "label": "25.220-70 表面处理和镀涂设备",

      }
    ]
  },
  {
    "value": "25-010",
    "label": "25-010 机械制造综合",

  },
  {
    "value": "27",
    "label": "27 能源和热传导工程",
    "children": [
      {
        "value": "27.010",
        "label": "27.010 能源和热传导工程综合",

      },
      {
        "value": "27.020",
        "label": "27.020 内燃机",

      },
      {
        "value": "27.040",
        "label": "27.040 燃气轮机和蒸汽轮机、蒸汽机",

      },
      {
        "value": "27.060",
        "label": "27.060 燃烧器、锅炉",
        "children": [
          {
            "value": "27.060.01",
            "label": "27.060.01 燃烧器、锅炉综合",

          },
          {
            "value": "27.060.10",
            "label": "27.060.10 液体和固体燃料燃烧器",

          },
          {
            "value": "27.060.20",
            "label": "27.060.20 气体燃料燃烧器",

          },
          {
            "value": "27.060.30",
            "label": "27.060.30 锅炉和热交换器",

          }
        ]
      },
      {
        "value": "27.070",
        "label": "27.070 燃料电池",

      },
      {
        "value": "27.080",
        "label": "27.080 热泵",

      },
      {
        "value": "27.100",
        "label": "27.100 电站综合",

      },
      {
        "value": "27.120",
        "label": "27.120 核能工程",
        "children": [
          {
            "value": "27.120.01",
            "label": "27.120.01 核能综合",

          },
          {
            "value": "27.120.10",
            "label": "27.120.10 反应堆工程",

          },
          {
            "value": "27.120.20",
            "label": "27.120.20 核电站、安全",

          },
          {
            "value": "27.120.30",
            "label": "27.120.30 裂变物质",

          },
          {
            "value": "27.120.99",
            "label": "27.120.99 有关核能的其他标准",

          }
        ]
      },
      {
        "value": "27.140",
        "label": "27.140 水力工程",

      },
      {
        "value": "27.160",
        "label": "27.160 太阳能工程",

      },
      {
        "value": "27.180",
        "label": "27.180 风力发电系统和其他能源",

      },
      {
        "value": "27.200",
        "label": "27.200 制冷技术",

      },
      {
        "value": "27.220",
        "label": "27.220 热回收、绝热",

      }
    ]
  },
  {
    "value": "29",
    "label": "29 电气工程",
    "children": [
      {
        "value": "29.020",
        "label": "29.020 电气工程综合",

      },
      {
        "value": "29.030",
        "label": "29.030 磁性材料",

      },
      {
        "value": "29.035",
        "label": "29.035 绝缘材料",
        "children": [
          {
            "value": "29.035.01",
            "label": "29.035.01 绝缘材料综合",

          },
          {
            "value": "29.035.10",
            "label": "29.035.10 纸和纸板绝缘材料",

          },
          {
            "value": "29.035.20",
            "label": "29.035.20 塑料和橡胶绝缘材料",

          },
          {
            "value": "29.035.30",
            "label": "29.035.30 陶瓷和玻璃绝缘材料",

          },
          {
            "value": "29.035.50",
            "label": "29.035.50 云母基材料",

          },
          {
            "value": "29.035.60",
            "label": "29.035.60 涂层织物",

          },
          {
            "value": "29.035.99",
            "label": "29.035.99 其他绝缘材料",

          }
        ]
      },
      {
        "value": "29.040",
        "label": "29.040 绝缘流体",
        "children": [
          {
            "value": "29.040.01",
            "label": "29.040.01 绝缘流体综合",

          },
          {
            "value": "29.040.10",
            "label": "29.040.10 绝缘油",

          },
          {
            "value": "29.040.20",
            "label": "29.040.20 绝缘气体",

          },
          {
            "value": "29.040.99",
            "label": "29.040.99 其他绝缘流体",

          }
        ]
      },
      {
        "value": "29.045",
        "label": "29.045 半导体材料",

      },
      {
        "value": "29.050",
        "label": "29.050 导体材料",

      },
      {
        "value": "29.060",
        "label": "29.060 电线和电缆",
        "children": [
          {
            "value": "29.060.01",
            "label": "29.060.01 电线和电缆综合",

          },
          {
            "value": "29.060.10",
            "label": "29.060.10 电线",

          },
          {
            "value": "29.060.20",
            "label": "29.060.20 电缆",

          }
        ]
      },
      {
        "value": "29.080",
        "label": "29.080 绝缘",
        "children": [
          {
            "value": "29.080.01",
            "label": "29.080.01 电绝缘综合",

          },
          {
            "value": "29.080.10",
            "label": "29.080.10 绝缘子",

          },
          {
            "value": "29.080.20",
            "label": "29.080.20 套管",

          },
          {
            "value": "29.080.30",
            "label": "29.080.30 绝缘系统",

          },
          {
            "value": "29.080.99",
            "label": "29.080.99 有关绝缘的其他标准",

          }
        ]
      },
      {
        "value": "29.100",
        "label": "29.100 电气设备元件",
        "children": [
          {
            "value": "29.100.01",
            "label": "29.100.01 电气设备元件综合",

          },
          {
            "value": "29.100.10",
            "label": "29.100.10 磁性元件",

          },
          {
            "value": "29.100.20",
            "label": "29.100.20 电气和机电元件",

          },
          {
            "value": "29.100.99",
            "label": "29.100.99 电气设备用其他元件",

          }
        ]
      },
      {
        "value": "29.120",
        "label": "29.120 电工器件",
        "children": [
          {
            "value": "29.120.01",
            "label": "29.120.01 电工器件综合",

          },
          {
            "value": "29.120.10",
            "label": "29.120.10 导线管",

          },
          {
            "value": "29.120.20",
            "label": "29.120.20 连接装置",

          },
          {
            "value": "29.120.30",
            "label": "29.120.30 插头、插座、连接器",

          },
          {
            "value": "29.120.40",
            "label": "29.120.40 开关",

          },
          {
            "value": "29.120.50",
            "label": "29.120.50 熔断器和其他过载保护装置",

          },
          {
            "value": "29.120.70",
            "label": "29.120.70 继电器",

          },
          {
            "value": "29.120.99",
            "label": "29.120.99 其他电工器件",

          }
        ]
      },
      {
        "value": "29.130",
        "label": "29.130 开关装置和控制器",
        "children": [
          {
            "value": "29.130.01",
            "label": "29.130.01 开关装置和控制器综合",

          },
          {
            "value": "29.130.10",
            "label": "29.130.10 高压开关装置和控制器",

          },
          {
            "value": "29.130.20",
            "label": "29.130.20 低压开关装置和控制器",

          },
          {
            "value": "29.130.99",
            "label": "29.130.99 其他开关装置和控制器",

          }
        ]
      },
      {
        "value": "29.140",
        "label": "29.140 电灯及有关装置",
        "children": [
          {
            "value": "29.140.01",
            "label": "29.140.01 电灯综合",

          },
          {
            "value": "29.140.10",
            "label": "29.140.10 灯头和灯座",

          },
          {
            "value": "29.140.20",
            "label": "29.140.20 白炽灯",

          },
          {
            "value": "29.140.30",
            "label": "29.140.30 荧光灯、放电灯",

          },
          {
            "value": "29.140.40",
            "label": "29.140.40 照明设备",

          },
          {
            "value": "29.140.50",
            "label": "29.140.50 照明安装系统",

          },
          {
            "value": "29.140.99",
            "label": "29.140.99 有关灯的其他标准",

          }
        ]
      },
      {
        "value": "29.160",
        "label": "29.160 旋转电机",
        "children": [
          {
            "value": "29.160.01",
            "label": "29.160.01 旋转电机综合",

          },
          {
            "value": "29.160.10",
            "label": "29.160.10 旋转电机部件",

          },
          {
            "value": "29.160.20",
            "label": "29.160.20 发电机",

          },
          {
            "value": "29.160.30",
            "label": "29.160.30 电动机",

          },
          {
            "value": "29.160.40",
            "label": "29.160.40 发电机组",

          },
          {
            "value": "29.160.99",
            "label": "29.160.99 有关旋转电机的其他标准",

          }
        ]
      },
      {
        "value": "29.160-60",
        "label": "29.160-60 微特电机和特殊电机",

      },
      {
        "value": "29.180",
        "label": "29.180 变压器、电抗器、电感器",

      },
      {
        "value": "29.200",
        "label": "29.200 整流器、转换器、稳压电源",

      },
      {
        "value": "29.220",
        "label": "29.220 电池和蓄电池",
        "children": [
          {
            "value": "29.220.01",
            "label": "29.220.01 电池和蓄电池综合",

          },
          {
            "value": "29.220.10",
            "label": "29.220.10 原电池和蓄电池",

          },
          {
            "value": "29.220.20",
            "label": "29.220.20 酸性蓄电池",

          },
          {
            "value": "29.220.30",
            "label": "29.220.30 碱性蓄电池",

          },
          {
            "value": "29.220.99",
            "label": "29.220.99 其他电池和蓄电池",

          }
        ]
      },
      {
        "value": "29.240",
        "label": "29.240 输电网和配电网",
        "children": [
          {
            "value": "29.240.01",
            "label": "29.240.01 输电网和配电网综合",

          },
          {
            "value": "29.240.10",
            "label": "29.240.10 变电站、电涌放电器",

          },
          {
            "value": "29.240.20",
            "label": "29.240.20 输电线路和配电线路",

          },
          {
            "value": "29.240.30",
            "label": "29.240.30 电力系统用控制设备",

          },
          {
            "value": "29.240.99",
            "label": "29.240.99 其他有关输电网和配电网的设备",

          }
        ]
      },
      {
        "value": "29.260",
        "label": "29.260 特殊工作条件下用电气设备",
        "children": [
          {
            "value": "29.260.01",
            "label": "29.260.01 特殊工作条件下用电气设备综合",

          },
          {
            "value": "29.260.10",
            "label": "29.260.10 户外用电气设备",

          },
          {
            "value": "29.260.20",
            "label": "29.260.20 易爆环境用电气设备",

          },
          {
            "value": "29.260.99",
            "label": "29.260.99 特殊工作条件用其他电气设备",

          }
        ]
      },
      {
        "value": "29.280",
        "label": "29.280 电力牵引设备",

      }
    ]
  },
  {
    "value": "31",
    "label": "31 电子学",
    "children": [
      {
        "value": "31.020",
        "label": "31.020 电子元器件综合",

      },
      {
        "value": "31.040",
        "label": "31.040 电阻器",
        "children": [
          {
            "value": "31.040.01",
            "label": "31.040.01 电阻器综合",

          },
          {
            "value": "31.040.10",
            "label": "31.040.10 固定电阻器",

          },
          {
            "value": "31.040.20",
            "label": "31.040.20 电位器、可变电阻器",

          },
          {
            "value": "31.040.30",
            "label": "31.040.30 热敏电阻器",

          },
          {
            "value": "31.040.99",
            "label": "31.040.99 其他电阻器",

          }
        ]
      },
      {
        "value": "31.060",
        "label": "31.060 电容器",
        "children": [
          {
            "value": "31.060.01",
            "label": "31.060.01 电容器综合",

          },
          {
            "value": "31.060.10",
            "label": "31.060.10 固定电容器",

          },
          {
            "value": "31.060.20",
            "label": "31.060.20 陶瓷电容器和云母电容器",

          },
          {
            "value": "31.060.30",
            "label": "31.060.30 纸介电容器和塑料膜电容器",

          },
          {
            "value": "31.060.40",
            "label": "31.060.40 钽电解电容器",

          },
          {
            "value": "31.060.50",
            "label": "31.060.50 铝电解电容器",

          },
          {
            "value": "31.060.60",
            "label": "31.060.60 可变电容器",

          },
          {
            "value": "31.060.70",
            "label": "31.060.70 电力电容器",

          },
          {
            "value": "31.060.99",
            "label": "31.060.99 其他电容器",

          }
        ]
      },
      {
        "value": "31.080",
        "label": "31.080 半导体分立器件",
        "children": [
          {
            "value": "31.080.01",
            "label": "31.080.01 半导体器分立件综合",

          },
          {
            "value": "31.080.10",
            "label": "31.080.10 二极管",

          },
          {
            "value": "31.080.20",
            "label": "31.080.20 晶体闸流管",

          },
          {
            "value": "31.080.30",
            "label": "31.080.30 三极管",

          },
          {
            "value": "31.080.99",
            "label": "31.080.99 其他半导体分立器件",

          }
        ]
      },
      {
        "value": "31.100",
        "label": "31.100 电子管",

      },
      {
        "value": "31.120",
        "label": "31.120 电子显示器件",

      },
      {
        "value": "31.140",
        "label": "31.140 频率控制和选择用压电器件与介质器件",

      },
      {
        "value": "31.160",
        "label": "31.160 滤波器",

      },
      {
        "value": "31.180",
        "label": "31.180 印制电路和印制电路板",

      },
      {
        "value": "31.190",
        "label": "31.190 电子元器件组件",

      },
      {
        "value": "31.200",
        "label": "31.200 集成电路、微电子学",

      },
      {
        "value": "31.220",
        "label": "31.220 电子电信设备用机电元件",
        "children": [
          {
            "value": "31.220.01",
            "label": "31.220.01 机电元件综合",

          },
          {
            "value": "31.220.10",
            "label": "31.220.10 插头和插座装置、连接器",

          },
          {
            "value": "31.220.20",
            "label": "31.220.20 开关",

          },
          {
            "value": "31.220.99",
            "label": "31.220.99 其他机电零部件",

          }
        ]
      },
      {
        "value": "31.240",
        "label": "31.240 电子设备用机械构件",

      },
      {
        "value": "31.260",
        "label": "31.260 光电子学、激光设备",

      }
    ]
  },
  {
    "value": "31-030",
    "label": "31-030 电子技术专用材料",

  },
  {
    "value": "31-070",
    "label": "31-070 敏感元件和传感器",

  },
  {
    "value": "31-550",
    "label": "31-550 电子产品生产设备",

  },
  {
    "value": "33",
    "label": "33 电信、音频和视频工程",
    "children": [
      {
        "value": "33.020",
        "label": "33.020 电信综合",

      },
      {
        "value": "33.030",
        "label": "33.030 电信业务、应用",

      },
      {
        "value": "33.040",
        "label": "33.040 电信系统",
        "children": [
          {
            "value": "33.040.01",
            "label": "33.040.01 电信系统综合",

          },
          {
            "value": "33.040.20",
            "label": "33.040.20 传输系统",

          },
          {
            "value": "33.040.30",
            "label": "33.040.30 交换和信令系统",

          },
          {
            "value": "33.040.35",
            "label": "33.040.35 电话网",

          },
          {
            "value": "33.040.40",
            "label": "33.040.40 数据通信网",

          },
          {
            "value": "33.040.50",
            "label": "33.040.50 线路、连接和电路",

          },
          {
            "value": "33.040.99",
            "label": "33.040.99 其他电信系统用设备",

          }
        ]
      },
      {
        "value": "33.050",
        "label": "33.050 电信终端设备",
        "children": [
          {
            "value": "33.050.01",
            "label": "33.050.01 电信终端设备综合",

          },
          {
            "value": "33.050.10",
            "label": "33.050.10 电话设备",

          },
          {
            "value": "33.050.20",
            "label": "33.050.20 寻呼设备",

          },
          {
            "value": "33.050.30",
            "label": "33.050.30 用户电报、可视图文、用户传真设备",

          },
          {
            "value": "33.050.99",
            "label": "33.050.99 其他电信终端设备",

          }
        ]
      },
      {
        "value": "33.060",
        "label": "33.060 无线通信",
        "children": [
          {
            "value": "33.060.01",
            "label": "33.060.01 无线通信综合",

          },
          {
            "value": "33.060.20",
            "label": "33.060.20 接收和发射设备",

          },
          {
            "value": "33.060.30",
            "label": "33.060.30 无线中继和固定卫星通信系统",

          },
          {
            "value": "33.060.40",
            "label": "33.060.40 电缆分配系统",

          },
          {
            "value": "33.060.99",
            "label": "33.060.99 其他无线通信设备",

          }
        ]
      },
      {
        "value": "33.070",
        "label": "33.070 移动业务",
        "children": [
          {
            "value": "33.070.01",
            "label": "33.070.01 移动业务综合",

          },
          {
            "value": "33.070.10",
            "label": "33.070.10 地面集群无线系统(TETRA)",

          },
          {
            "value": "33.070.20",
            "label": "33.070.20 寻呼系统(ERMES)",

          },
          {
            "value": "33.070.30",
            "label": "33.070.30 数字增强型无绳通信(DECT)",

          },
          {
            "value": "33.070.40",
            "label": "33.070.40 卫星",

          },
          {
            "value": "33.070.50",
            "label": "33.070.50 全球移动通信系统(GMS)",

          },
          {
            "value": "33.070.99",
            "label": "33.070.99 其他移动业务",

          }
        ]
      },
      {
        "value": "33.070-60",
        "label": "33.070-60 码分多址移动通信系统(CDMA)",

      },
      {
        "value": "33.080",
        "label": "33.080 综合业务数字网(ISDN)",

      },
      {
        "value": "33.100",
        "label": "33.100 电磁兼容性(EMC)",
        "children": [
          {
            "value": "33.100.01",
            "label": "33.100.01 电磁兼容性综合",

          },
          {
            "value": "33.100.10",
            "label": "33.100.10 发射",

          },
          {
            "value": "33.100.20",
            "label": "33.100.20 抗扰度",

          },
          {
            "value": "33.100.99",
            "label": "33.100.99 有关电磁兼容性的其他方面",

          }
        ]
      },
      {
        "value": "33.120",
        "label": "33.120 电信设备用部件和附件",
        "children": [
          {
            "value": "33.120.01",
            "label": "33.120.01 部件和附件综合",

          },
          {
            "value": "33.120.10",
            "label": "33.120.10 同轴电缆、波导和其他射频电缆",

          },
          {
            "value": "33.120.20",
            "label": "33.120.20 导线和对称电缆",

          },
          {
            "value": "33.120.30",
            "label": "33.120.30 射频连接器",

          },
          {
            "value": "33.120.40",
            "label": "33.120.40 天线",

          },
          {
            "value": "33.120.99",
            "label": "33.120.99 其他部件和附件",

          }
        ]
      },
      {
        "value": "33.140",
        "label": "33.140 电信专用测量设备",

      },
      {
        "value": "33.160",
        "label": "33.160 音频、视频和视听工程",
        "children": [
          {
            "value": "33.160.01",
            "label": "33.160.01 音频、视频和视听系统综合",

          },
          {
            "value": "33.160.10",
            "label": "33.160.10 放大器",

          },
          {
            "value": "33.160.20",
            "label": "33.160.20 无线电接收机",

          },
          {
            "value": "33.160.25",
            "label": "33.160.25 电视接收机",

          },
          {
            "value": "33.160.30",
            "label": "33.160.30 音频系统",

          },
          {
            "value": "33.160.40",
            "label": "33.160.40 视频系统",

          },
          {
            "value": "33.160.50",
            "label": "33.160.50 附件",

          },
          {
            "value": "33.160.60",
            "label": "33.160.60 多媒体系统和电话会议设备",

          },
          {
            "value": "33.160.99",
            "label": "33.160.99 其他音频、视频和视听设备",

          }
        ]
      },
      {
        "value": "33.170",
        "label": "33.170 电视播放和无线电广播",

      },
      {
        "value": "33.180",
        "label": "33.180 光纤通信",
        "children": [
          {
            "value": "33.180.01",
            "label": "33.180.01 光纤系统综合",

          },
          {
            "value": "33.180.10",
            "label": "33.180.10 光纤和光缆",

          },
          {
            "value": "33.180.20",
            "label": "33.180.20 纤维光学和光学互连器件",

          },
          {
            "value": "33.180.30",
            "label": "33.180.30 光纤放大器",

          },
          {
            "value": "33.180.99",
            "label": "33.180.99 其他光纤设备",

          }
        ]
      },
      {
        "value": "33.200",
        "label": "33.200 遥控、遥测",

      }
    ]
  },
  {
    "value": "35",
    "label": "35 信息技术、办公机械",
    "children": [
      {
        "value": "35.020",
        "label": "35.020 信息技术(IT)综合",

      },
      {
        "value": "35.040",
        "label": "35.040 字符集和信息编码",

      },
      {
        "value": "35.060",
        "label": "35.060 信息技术用语言",

      },
      {
        "value": "35.080",
        "label": "35.080 软件开发和系统文件",

      },
      {
        "value": "35.100",
        "label": "35.100 开放系统互连(OSI)",
        "children": [
          {
            "value": "35.100.01",
            "label": "35.100.01 开放系统互连(OSI)综合",

          },
          {
            "value": "35.100.05",
            "label": "35.100.05 多层应用",

          },
          {
            "value": "35.100.10",
            "label": "35.100.10 物理层",

          },
          {
            "value": "35.100.20",
            "label": "35.100.20 数据链路层",

          },
          {
            "value": "35.100.30",
            "label": "35.100.30 网络层",

          },
          {
            "value": "35.100.40",
            "label": "35.100.40 传输层",

          },
          {
            "value": "35.100.50",
            "label": "35.100.50 会话层",

          },
          {
            "value": "35.100.60",
            "label": "35.100.60 表示层",

          },
          {
            "value": "35.100.70",
            "label": "35.100.70 应用层",

          }
        ]
      },
      {
        "value": "35.110",
        "label": "35.110 网络",

      },
      {
        "value": "35.140",
        "label": "35.140 计算机图形技术",

      },
      {
        "value": "35.160",
        "label": "35.160 微处理机系统",

      },
      {
        "value": "35.180",
        "label": "35.180 IT终端和其他外围设备",

      },
      {
        "value": "35.200",
        "label": "35.200 接口和互连设备",

      },
      {
        "value": "35.220",
        "label": "35.220 数据存储设备",
        "children": [
          {
            "value": "35.220.01",
            "label": "35.220.01 数据存储设备综合",

          },
          {
            "value": "35.220.10",
            "label": "35.220.10 纸卡和纸带",

          },
          {
            "value": "35.220.20",
            "label": "35.220.20 磁存储设备综合",

          },
          {
            "value": "35.220.21",
            "label": "35.220.21 磁盘",

          },
          {
            "value": "35.220.22",
            "label": "35.220.22 磁带",

          },
          {
            "value": "35.220.23",
            "label": "35.220.23 盒式磁带和磁带盒",

          },
          {
            "value": "35.220.30",
            "label": "35.220.30 光学存储设备",

          },
          {
            "value": "35.220.99",
            "label": "35.220.99 其他数据存储装置",

          }
        ]
      },
      {
        "value": "35.240",
        "label": "35.240 信息技术应用",
        "children": [
          {
            "value": "35.240.01",
            "label": "35.240.01 信息技术应用综合",

          },
          {
            "value": "35.240.10",
            "label": "35.240.10 计算机辅助设计(CAD)",

          },
          {
            "value": "35.240.15",
            "label": "35.240.15 识别卡和有关装置",

          },
          {
            "value": "35.240.20",
            "label": "35.240.20 信息技术在办公中的应用",

          },
          {
            "value": "35.240.30",
            "label": "35.240.30 信息技术在信息、文献和出版中的应用",

          },
          {
            "value": "35.240.40",
            "label": "35.240.40 信息技术在银行中的应用",

          },
          {
            "value": "35.240.50",
            "label": "35.240.50 信息技术在工业中的应用",

          },
          {
            "value": "35.240.60",
            "label": "35.240.60 信息技术在运输和贸易中的应用",

          },
          {
            "value": "35.240.70",
            "label": "35.240.70 信息技术在自然科学中的应用",

          },
          {
            "value": "35.240.80",
            "label": "35.240.80 信息技术在医药卫生技术中的应用",

          },
          {
            "value": "35.240.99",
            "label": "35.240.99 信息技术在其他领域中的应用",

          }
        ]
      },
      {
        "value": "35.260",
        "label": "35.260 办公机械",

      },
      {
        "value": "35.030",
        "label": "35.030 信息安全技术[包括加密]",

      }
    ]
  },
  {
    "value": "37",
    "label": "37 成像技术",
    "children": [
      {
        "value": "37.020",
        "label": "37.020 光学设备",

      },
      {
        "value": "37.040",
        "label": "37.040 摄影技术",
        "children": [
          {
            "value": "37.040.01",
            "label": "37.040.01 摄影技术综合",

          },
          {
            "value": "37.040.10",
            "label": "37.040.10 摄影设备、投影仪",

          },
          {
            "value": "37.040.20",
            "label": "37.040.20 相纸、胶卷和暗盒",

          },
          {
            "value": "37.040.25",
            "label": "37.040.25 射线照相胶片",

          },
          {
            "value": "37.040.30",
            "label": "37.040.30 摄影用化学药品",

          },
          {
            "value": "37.040.99",
            "label": "37.040.99 有关摄影技术的其他标准",

          }
        ]
      },
      {
        "value": "37.060",
        "label": "37.060 电影",
        "children": [
          {
            "value": "37.060.01",
            "label": "37.060.01 电影综合",

          },
          {
            "value": "37.060.10",
            "label": "37.060.10 电影设备",

          },
          {
            "value": "37.060.20",
            "label": "37.060.20 电影胶片、暗盒",

          },
          {
            "value": "37.060.99",
            "label": "37.060.99 有关电影的其他标准",

          }
        ]
      },
      {
        "value": "37.080",
        "label": "37.080 文献成像象技术",

      },
      {
        "value": "37.100",
        "label": "37.100 印制技术",
        "children": [
          {
            "value": "37.100.01",
            "label": "37.100.01 印制技术综合",

          },
          {
            "value": "37.100.10",
            "label": "37.100.10 印刷、复制设备",

          },
          {
            "value": "37.100.20",
            "label": "37.100.20 印制材料",

          },
          {
            "value": "37.100.99",
            "label": "37.100.99 有关印制技术的其他标准",

          }
        ]
      }
    ]
  },
  {
    "value": "37-010",
    "label": "37-010 成像技术综合",

  },
  {
    "value": "39",
    "label": "39 精密机械、珠宝",
    "children": [
      {
        "value": "39.020",
        "label": "39.020 精密机械",

      },
      {
        "value": "39.040",
        "label": "39.040 钟表学",
        "children": [
          {
            "value": "39.040.01",
            "label": "39.040.01 钟表学综合",

          },
          {
            "value": "39.040.10",
            "label": "39.040.10 手表",

          },
          {
            "value": "39.040.20",
            "label": "39.040.20 钟",

          },
          {
            "value": "39.040.99",
            "label": "39.040.99 其他计时仪器",

          }
        ]
      },
      {
        "value": "39.060",
        "label": "39.060 珠宝",

      }
    ]
  },
  {
    "value": "43",
    "label": "43 道路车辆工程",
    "children": [
      {
        "value": "43.020",
        "label": "43.020 道路车辆综合",

      },
      {
        "value": "43.040",
        "label": "43.040 道路车辆装置",
        "children": [
          {
            "value": "43.040.01",
            "label": "43.040.01 道路车辆装置综合",

          },
          {
            "value": "43.040.10",
            "label": "43.040.10 电气和电子设备",

          },
          {
            "value": "43.040.15",
            "label": "43.040.15 车用信息技术、车载计算机系统",

          },
          {
            "value": "43.040.20",
            "label": "43.040.20 照明、信号和警告设备",

          },
          {
            "value": "43.040.30",
            "label": "43.040.30 指示和控制装置",

          },
          {
            "value": "43.040.40",
            "label": "43.040.40 制动系统",

          },
          {
            "value": "43.040.50",
            "label": "43.040.50 传动装置、悬挂装置",

          },
          {
            "value": "43.040.60",
            "label": "43.040.60 车身及车身附件",

          },
          {
            "value": "43.040.65",
            "label": "43.040.65 玻璃窗和刮水器",

          },
          {
            "value": "43.040.70",
            "label": "43.040.70 联轴器",

          },
          {
            "value": "43.040.80",
            "label": "43.040.80 安全设备和紧束装置",

          },
          {
            "value": "43.040.99",
            "label": "43.040.99 其他道路车辆装置",

          }
        ]
      },
      {
        "value": "43.060",
        "label": "43.060 道路车辆内燃机",
        "children": [
          {
            "value": "43.060.01",
            "label": "43.060.01 道路车辆内燃机综合",

          },
          {
            "value": "43.060.10",
            "label": "43.060.10 气缸体和内部组件",

          },
          {
            "value": "43.060.20",
            "label": "43.060.20 增压冲气、进气/排气管路系统",

          },
          {
            "value": "43.060.30",
            "label": "43.060.30 冷却系统、润滑系统",

          },
          {
            "value": "43.060.40",
            "label": "43.060.40 燃油系统",

          },
          {
            "value": "43.060.50",
            "label": "43.060.50 电气和电子设备、控制系统",

          },
          {
            "value": "43.060.99",
            "label": "43.060.99 其他内燃机装置和组件",

          }
        ]
      },
      {
        "value": "43.080",
        "label": "43.080 商用车辆",
        "children": [
          {
            "value": "43.080.01",
            "label": "43.080.01 商用车辆综合",

          },
          {
            "value": "43.080.10",
            "label": "43.080.10 卡车和挂车",

          },
          {
            "value": "43.080.20",
            "label": "43.080.20 客车",

          },
          {
            "value": "43.080.99",
            "label": "43.080.99 其他商用车辆",

          }
        ]
      },
      {
        "value": "43.100",
        "label": "43.100 乘用车、篷车和轻型挂车",

      },
      {
        "value": "43.120",
        "label": "43.120 电车",

      },
      {
        "value": "43.140",
        "label": "43.140 摩托车和机动自行车",

      },
      {
        "value": "43.150",
        "label": "43.150 自行车",

      },
      {
        "value": "43.160",
        "label": "43.160 特种车辆",

      },
      {
        "value": "43.180",
        "label": "43.180 检查、维修和试验设备",

      }
    ]
  },
  {
    "value": "45",
    "label": "45 铁路工程",
    "children": [
      {
        "value": "45.020",
        "label": "45.020 铁路工程综合",

      },
      {
        "value": "45.040",
        "label": "45.040 铁路工程材料和零件",

      },
      {
        "value": "45.060",
        "label": "45.060 铁路车辆",
        "children": [
          {
            "value": "45.060.01",
            "label": "45.060.01 铁路车辆综合",

          },
          {
            "value": "45.060.10",
            "label": "45.060.10 机车",

          },
          {
            "value": "45.060.20",
            "label": "45.060.20 车辆",

          }
        ]
      },
      {
        "value": "45.080",
        "label": "45.080 钢轨和线路构件",

      },
      {
        "value": "45.100",
        "label": "45.100 索道设备",

      },
      {
        "value": "45.120",
        "label": "45.120 铁路/索道建造和维护设备",

      }
    ]
  },
  {
    "value": "47",
    "label": "47 造船和海上构筑物",
    "children": [
      {
        "value": "47.020",
        "label": "47.020 造船和海上构筑物综合",
        "children": [
          {
            "value": "47.020.01",
            "label": "47.020.01 造船和海上构筑物通用标准",

          },
          {
            "value": "47.020.05",
            "label": "47.020.05 造船用材料和零件",

          },
          {
            "value": "47.020.10",
            "label": "47.020.10 船体及其构件",

          },
          {
            "value": "47.020.20",
            "label": "47.020.20 船用发动机和推进系统",

          },
          {
            "value": "47.020.30",
            "label": "47.020.30 管路系统",

          },
          {
            "value": "47.020.40",
            "label": "47.020.40 起重设备和货物搬运设备",

          },
          {
            "value": "47.020.50",
            "label": "47.020.50 甲板设备和装置",

          },
          {
            "value": "47.020.60",
            "label": "47.020.60 船舶和海上构筑物用电气设备",

          },
          {
            "value": "47.020.70",
            "label": "47.020.70 导航和控制设备",

          },
          {
            "value": "47.020.80",
            "label": "47.020.80 起居舱室",

          },
          {
            "value": "47.020.85",
            "label": "47.020.85 货舱",

          },
          {
            "value": "47.020.90",
            "label": "47.020.90 船用通风、空气调节和供热系统",

          },
          {
            "value": "47.020.99",
            "label": "47.020.99 有关造船和海上构筑物的其他标准",

          }
        ]
      },
      {
        "value": "47.040",
        "label": "47.040 远洋轮",

      },
      {
        "value": "47.060",
        "label": "47.060 内河船",

      },
      {
        "value": "47.080",
        "label": "47.080 小型船",

      }
    ]
  },
  {
    "value": "49",
    "label": "49 航空器和航天器工程",
    "children": [
      {
        "value": "49.020",
        "label": "49.020 航空器和航天器综合",

      },
      {
        "value": "49.025",
        "label": "49.025 航空航天制造用材料",
        "children": [
          {
            "value": "49.025.01",
            "label": "49.025.01 航空航天制造用材料综合",

          },
          {
            "value": "49.025.05",
            "label": "49.025.05 黑色金属合金综合",

          },
          {
            "value": "49.025.10",
            "label": "49.025.10 钢",

          },
          {
            "value": "49.025.15",
            "label": "49.025.15 有色金属合金综合",

          },
          {
            "value": "49.025.20",
            "label": "49.025.20 铝",

          },
          {
            "value": "49.025.30",
            "label": "49.025.30 钛",

          },
          {
            "value": "49.025.40",
            "label": "49.025.40 橡胶和塑料",

          },
          {
            "value": "49.025.50",
            "label": "49.025.50 粘合剂",

          },
          {
            "value": "49.025.60",
            "label": "49.025.60 织物",

          },
          {
            "value": "49.025.99",
            "label": "49.025.99 其他材料",

          }
        ]
      },
      {
        "value": "49.030",
        "label": "49.030 航空航天制造用紧固件",
        "children": [
          {
            "value": "49.030.01",
            "label": "49.030.01 紧固件综合",

          },
          {
            "value": "49.030.10",
            "label": "49.030.10 螺纹",

          },
          {
            "value": "49.030.20",
            "label": "49.030.20 螺栓、螺钉、螺柱",

          },
          {
            "value": "49.030.30",
            "label": "49.030.30 螺母",

          },
          {
            "value": "49.030.40",
            "label": "49.030.40 销钉、铁钉",

          },
          {
            "value": "49.030.50",
            "label": "49.030.50 垫圈和其他锁紧元件",

          },
          {
            "value": "49.030.60",
            "label": "49.030.60 铆钉",

          },
          {
            "value": "49.030.99",
            "label": "49.030.99 其他紧固件",

          }
        ]
      },
      {
        "value": "49.035",
        "label": "49.035 航空航天制造用零部件",

      },
      {
        "value": "49.040",
        "label": "49.040 有关航空航天制造用镀涂和有关工艺",

      },
      {
        "value": "49.045",
        "label": "49.045 结构和结构元件",

      },
      {
        "value": "49.050",
        "label": "49.050 航空航天发动机和推进系统",

      },
      {
        "value": "49.060",
        "label": "49.060 航空航天用电气设备和系统",

      },
      {
        "value": "49.080",
        "label": "49.080 航空航天用流体系统和零部件",

      },
      {
        "value": "49.090",
        "label": "49.090 机上设备和仪器",

      },
      {
        "value": "49.095",
        "label": "49.095 客运设备和座舱设备",

      },
      {
        "value": "49.100",
        "label": "49.100 地面服务和维修设备",

      },
      {
        "value": "49.120",
        "label": "49.120 货运设备",

      },
      {
        "value": "49.140",
        "label": "49.140 航天系统和操作装置",

      }
    ]
  },
  {
    "value": "53",
    "label": "53 材料储运设备",
    "children": [
      {
        "value": "53.020",
        "label": "53.020 起重设备",
        "children": [
          {
            "value": "53.020.01",
            "label": "53.020.01 起重设备综合",

          },
          {
            "value": "53.020.20",
            "label": "53.020.20 起重机",

          },
          {
            "value": "53.020.30",
            "label": "53.020.30 起重设备附件",

          },
          {
            "value": "53.020.99",
            "label": "53.020.99 其他起重设备",

          }
        ]
      },
      {
        "value": "53.040",
        "label": "53.040 连续搬运设备",
        "children": [
          {
            "value": "53.040.01",
            "label": "53.040.01 连续搬运设备综合",

          },
          {
            "value": "53.040.10",
            "label": "53.040.10 输送机",

          },
          {
            "value": "53.040.20",
            "label": "53.040.20 输送机零部件",

          },
          {
            "value": "53.040.30",
            "label": "53.040.30 气动运输及其零部件",

          },
          {
            "value": "53.040.99",
            "label": "53.040.99 其他连续搬运设备",

          }
        ]
      },
      {
        "value": "53.060",
        "label": "53.060 工业车辆",

      },
      {
        "value": "53.080",
        "label": "53.080 储藏设备",

      },
      {
        "value": "53.100",
        "label": "53.100 土方机械",

      },
      {
        "value": "53.120",
        "label": "53.120 手工搬运工具",

      }
    ]
  },
  {
    "value": "55",
    "label": "55 货物的包装和调运",
    "children": [
      {
        "value": "55.020",
        "label": "55.020 货物的包装和调运综合",

      },
      {
        "value": "55.040",
        "label": "55.040 包装材料和辅助物",

      },
      {
        "value": "55.060",
        "label": "55.060 卷轴、线轴",

      },
      {
        "value": "55.080",
        "label": "55.080 麻袋、袋子",

      },
      {
        "value": "55.100",
        "label": "55.100 瓶、小罐、瓮",

      },
      {
        "value": "55.120",
        "label": "55.120 罐、听、管",

      },
      {
        "value": "55.130",
        "label": "55.130 雾化剂罐",

      },
      {
        "value": "55.140",
        "label": "55.140 粗腰桶、桶、筒等",

      },
      {
        "value": "55.160",
        "label": "55.160 箱、盒、板条箱",

      },
      {
        "value": "55.180",
        "label": "55.180 货物调运",
        "children": [
          {
            "value": "55.180.01",
            "label": "55.180.01 货物调运综合",

          },
          {
            "value": "55.180.10",
            "label": "55.180.10 通用集装箱",

          },
          {
            "value": "55.180.20",
            "label": "55.180.20 通用托盘",

          },
          {
            "value": "55.180.30",
            "label": "55.180.30 空运集装箱、托盘和网",

          },
          {
            "value": "55.180.40",
            "label": "55.180.40 满装和整装运输包",

          },
          {
            "value": "55.180.99",
            "label": "55.180.99 有关货物调运的其他标准",

          }
        ]
      },
      {
        "value": "55.200",
        "label": "55.200 包装机械",

      },
      {
        "value": "55.220",
        "label": "55.220 堆栈、仓储",

      },
      {
        "value": "55.230",
        "label": "55.230 发售机和自动售货机",

      }
    ]
  },
  {
    "value": "59",
    "label": "59 纺织和皮革技术",
    "children": [
      {
        "value": "59.020",
        "label": "59.020 纺织工艺",

      },
      {
        "value": "59.040",
        "label": "59.040 纺织辅助材料",

      },
      {
        "value": "59.060",
        "label": "59.060 纺织纤维",
        "children": [
          {
            "value": "59.060.01",
            "label": "59.060.01 纺织纤维综合",

          },
          {
            "value": "59.060.10",
            "label": "59.060.10 天然纤维",

          },
          {
            "value": "59.060.20",
            "label": "59.060.20 人造纤维",

          },
          {
            "value": "59.060.30",
            "label": "59.060.30 矿物纤维和金属纤维",

          },
          {
            "value": "59.060.99",
            "label": "59.060.99 其他纺织纤维",

          }
        ]
      },
      {
        "value": "59.080",
        "label": "59.080 纺织产品",
        "children": [
          {
            "value": "59.080.01",
            "label": "59.080.01 纺织产品综合",

          },
          {
            "value": "59.080.20",
            "label": "59.080.20 纱线",

          },
          {
            "value": "59.080.30",
            "label": "59.080.30 纺织物",

          },
          {
            "value": "59.080.40",
            "label": "59.080.40 涂覆织物",

          },
          {
            "value": "59.080.50",
            "label": "59.080.50 绳",

          },
          {
            "value": "59.080.60",
            "label": "59.080.60 铺地织物",

          },
          {
            "value": "59.080.70",
            "label": "59.080.70 土工布",

          },
          {
            "value": "59.080.99",
            "label": "59.080.99 其他纺织产品",

          }
        ]
      },
      {
        "value": "59.100",
        "label": "59.100 复合增强材料",
        "children": [
          {
            "value": "59.100.01",
            "label": "59.100.01 复合增强材料综合",

          },
          {
            "value": "59.100.10",
            "label": "59.100.10 纺织玻璃纤维材料",

          },
          {
            "value": "59.100.20",
            "label": "59.100.20 碳纤维材料",

          },
          {
            "value": "59.100.30",
            "label": "59.100.30 聚芳基酰胺材料",

          },
          {
            "value": "59.100.99",
            "label": "59.100.99 其他复合增强材料",

          }
        ]
      },
      {
        "value": "59.120",
        "label": "59.120 纺织机械",
        "children": [
          {
            "value": "59.120.01",
            "label": "59.120.01 纺织机械综合",

          },
          {
            "value": "59.120.10",
            "label": "59.120.10 纺纱、加捻和卷曲变形机械",

          },
          {
            "value": "59.120.20",
            "label": "59.120.20 络纱机器和设备",

          },
          {
            "value": "59.120.30",
            "label": "59.120.30 织机、织造机器",

          },
          {
            "value": "59.120.40",
            "label": "59.120.40 针织机械",

          },
          {
            "value": "59.120.50",
            "label": "59.120.50 印染和整理机械设备",

          },
          {
            "value": "59.120.99",
            "label": "59.120.99 其他纺织机械",

          }
        ]
      },
      {
        "value": "59.140",
        "label": "59.140 皮革技术",
        "children": [
          {
            "value": "59.140.01",
            "label": "59.140.01 皮革技术综合",

          },
          {
            "value": "59.140.10",
            "label": "59.140.10 加工和辅助材料",

          },
          {
            "value": "59.140.20",
            "label": "59.140.20 原皮、生皮和毛皮",

          },
          {
            "value": "59.140.30",
            "label": "59.140.30 皮革和裘皮",

          },
          {
            "value": "59.140.35",
            "label": "59.140.35 皮革制品",

          },
          {
            "value": "59.140.40",
            "label": "59.140.40 皮革和毛皮加工机械和设备",

          },
          {
            "value": "59.140.99",
            "label": "59.140.99 有关皮革技术的其他标准",

          }
        ]
      }
    ]
  },
  {
    "value": "59-010",
    "label": "59-010 纺织和皮革技术综合",

  },
  {
    "value": "61",
    "label": "61 服装工业",
    "children": [
      {
        "value": "61.020",
        "label": "61.020 服装",

      },
      {
        "value": "61.040",
        "label": "61.040 帽子、服饰品、衣扣",

      },
      {
        "value": "61.060",
        "label": "61.060 鞋类",

      },
      {
        "value": "61.080",
        "label": "61.080 服装工业用缝纫机和其他设备",

      }
    ]
  },
  {
    "value": "65",
    "label": "65 农业",
    "children": [
      {
        "value": "65.020",
        "label": "65.020 农业和林业",
        "children": [
          {
            "value": "65.020.01",
            "label": "65.020.01 农业和林业综合",

          },
          {
            "value": "65.020.20",
            "label": "65.020.20 植物栽培",

          },
          {
            "value": "65.020.30",
            "label": "65.020.30 动物饲养和繁殖",

          },
          {
            "value": "65.020.40",
            "label": "65.020.40 绿化和造林",

          },
          {
            "value": "65.020.99",
            "label": "65.020.99 有关农业和林业的其他标准",

          }
        ]
      },
      {
        "value": "65.040",
        "label": "65.040 农用建筑物、结构和装置",
        "children": [
          {
            "value": "65.040.01",
            "label": "65.040.01 农用建筑物和装置综合",

          },
          {
            "value": "65.040.10",
            "label": "65.040.10 家畜建筑物、装置和设备",

          },
          {
            "value": "65.040.20",
            "label": "65.040.20 农产品加工和贮存用建筑物和装置",

          },
          {
            "value": "65.040.30",
            "label": "65.040.30 温室和其他装置",

          },
          {
            "value": "65.040.99",
            "label": "65.040.99 有关农用建筑物和装置的其他标准",

          }
        ]
      }
    ]
  },
  {
    "value": "65-050",
    "label": "65-050 林产化工原料",
    "children": [
      {
        "value": "65.060",
        "label": "65.060 农业机械、工具和设备",
        "children": [
          {
            "value": "65.060.01",
            "label": "65.060.01 农业机械和设备综合",

          },
          {
            "value": "65.060.10",
            "label": "65.060.10 农业拖拉机和牵引车辆",

          },
          {
            "value": "65.060.20",
            "label": "65.060.20 耕作机械",

          },
          {
            "value": "65.060.25",
            "label": "65.060.25 肥料储存、制备和播撒设备",

          },
          {
            "value": "65.060.30",
            "label": "65.060.30 播种和种植设备",

          },
          {
            "value": "65.060.35",
            "label": "65.060.35 灌溉和排放设备",

          },
          {
            "value": "65.060.40",
            "label": "65.060.40 植保设备",

          },
          {
            "value": "65.060.50",
            "label": "65.060.50 收获设备",

          },
          {
            "value": "65.060.60",
            "label": "65.060.60 葡萄栽培和酿酒设备",

          },
          {
            "value": "65.060.70",
            "label": "65.060.70 园艺设备",

          },
          {
            "value": "65.060.80",
            "label": "65.060.80 林业设备",

          },
          {
            "value": "65.060.99",
            "label": "65.060.99 其他农业机械和设备",

          }
        ]
      },
      {
        "value": "65.080",
        "label": "65.080 肥料",

      },
      {
        "value": "65.100",
        "label": "65.100 杀虫剂和其他农用化工产品",
        "children": [
          {
            "value": "65.100.01",
            "label": "65.100.01 杀虫剂和其他农用化工产品综合",

          },
          {
            "value": "65.100.10",
            "label": "65.100.10 杀虫剂",

          },
          {
            "value": "65.100.20",
            "label": "65.100.20 除草剂",

          },
          {
            "value": "65.100.30",
            "label": "65.100.30 杀真菌剂",

          },
          {
            "value": "65.100.99",
            "label": "65.100.99 其他杀虫剂和农用化工产品",

          }
        ]
      },
      {
        "value": "65.120",
        "label": "65.120 饲料",

      },
      {
        "value": "65.140",
        "label": "65.140 养蜂",

      },
      {
        "value": "65.145",
        "label": "65.145 狩猎",

      },
      {
        "value": "65.150",
        "label": "65.150 捕捞和水产养殖",

      },
      {
        "value": "65.160",
        "label": "65.160 烟草、烟草制品和烟草工业设备",

      }
    ]
  },
  {
    "value": "67",
    "label": "67 食品技术",
    "children": [
      {
        "value": "67.020",
        "label": "67.020 食品工艺",

      },
      {
        "value": "67.040",
        "label": "67.040 食品综合",

      },
      {
        "value": "67.050",
        "label": "67.050 食品试验和分析的一般方法",

      },
      {
        "value": "67.060",
        "label": "67.060 谷物、豆类及其制品",

      },
      {
        "value": "67.080",
        "label": "67.080 水果、蔬菜及其制品",
        "children": [
          {
            "value": "67.080.01",
            "label": "67.080.01 水果、蔬菜及其制品综合",

          },
          {
            "value": "67.080.10",
            "label": "67.080.10 水果及其制品",

          },
          {
            "value": "67.080.20",
            "label": "67.080.20 蔬菜及其制品",

          }
        ]
      },
      {
        "value": "67.100",
        "label": "67.100 奶和奶制品",
        "children": [
          {
            "value": "67.100.01",
            "label": "67.100.01 奶和奶制品综合",

          },
          {
            "value": "67.100.10",
            "label": "67.100.10 奶及加工奶产品",

          },
          {
            "value": "67.100.20",
            "label": "67.100.20 奶油",

          },
          {
            "value": "67.100.30",
            "label": "67.100.30 乳酪",

          },
          {
            "value": "67.100.40",
            "label": "67.100.40 冰淇淋和果冻",

          },
          {
            "value": "67.100.99",
            "label": "67.100.99 其他奶制品",

          }
        ]
      },
      {
        "value": "67.120",
        "label": "67.120 肉、肉制品和其他动物类食品",
        "children": [
          {
            "value": "67.120.01",
            "label": "67.120.01 动物制品综合",

          },
          {
            "value": "67.120.10",
            "label": "67.120.10 肉和肉制品",

          },
          {
            "value": "67.120.20",
            "label": "67.120.20 家禽和蛋",

          },
          {
            "value": "67.120.30",
            "label": "67.120.30 鱼和水产品",

          },
          {
            "value": "67.120.99",
            "label": "67.120.99 其他动物制品",

          }
        ]
      },
      {
        "value": "67.140",
        "label": "67.140 茶、咖啡、可可",
        "children": [
          {
            "value": "67.140.10",
            "label": "67.140.10 茶",

          },
          {
            "value": "67.140.20",
            "label": "67.140.20 咖啡和咖啡代用品",

          },
          {
            "value": "67.140.30",
            "label": "67.140.30 可可",

          }
        ]
      },
      {
        "value": "67.160",
        "label": "67.160 饮料",
        "children": [
          {
            "value": "67.160.01",
            "label": "67.160.01 饮料综合",

          },
          {
            "value": "67.160.10",
            "label": "67.160.10 酒精饮料",

          },
          {
            "value": "67.160.20",
            "label": "67.160.20 无酒精饮料",

          }
        ]
      },
      {
        "value": "67.180",
        "label": "67.180 糖、糖制品、淀粉",
        "children": [
          {
            "value": "67.180.10",
            "label": "67.180.10 糖和糖制品",

          },
          {
            "value": "67.180.20",
            "label": "67.180.20 淀粉及衍生制品",

          }
        ]
      },
      {
        "value": "67.190",
        "label": "67.190 巧克力",

      },
      {
        "value": "67.200",
        "label": "67.200 食用油和脂肪、含油种子",
        "children": [
          {
            "value": "67.200.10",
            "label": "67.200.10 动物和植物的脂肪和油",

          },
          {
            "value": "67.200.20",
            "label": "67.200.20 含油种子",

          }
        ]
      },
      {
        "value": "67.220",
        "label": "67.220 香料和调料、食品添加剂",
        "children": [
          {
            "value": "67.220.10",
            "label": "67.220.10 香料和调料",

          },
          {
            "value": "67.220.20",
            "label": "67.220.20 食品添加剂",

          }
        ]
      },
      {
        "value": "67.230",
        "label": "67.230 预包装食品和精制食品",

      },
      {
        "value": "67.240",
        "label": "67.240 感官分析",

      },
      {
        "value": "67.250",
        "label": "67.250 与食品接触的物品与材料",

      },
      {
        "value": "67.260",
        "label": "67.260 食品工业厂房和设备",

      }
    ]
  },
  {
    "value": "71",
    "label": "71 化工技术",
    "children": [
      {
        "value": "71.020",
        "label": "71.020 化工生产",

      },
      {
        "value": "71.040",
        "label": "71.040 分析化学",
        "children": [
          {
            "value": "71.040.01",
            "label": "71.040.01 分析化学综合",

          },
          {
            "value": "71.040.10",
            "label": "71.040.10 化学实验室、实验室设备",

          },
          {
            "value": "71.040.20",
            "label": "71.040.20 实验室器皿和有关仪器",

          },
          {
            "value": "71.040.30",
            "label": "71.040.30 化学试剂",

          },
          {
            "value": "71.040.40",
            "label": "71.040.40 化学分析",

          },
          {
            "value": "71.040.50",
            "label": "71.040.50 物理化学分析方法",

          },
          {
            "value": "71.040.99",
            "label": "71.040.99 有关分析化学的其他标准",

          }
        ]
      },
      {
        "value": "71.060",
        "label": "71.060 无机化学",
        "children": [
          {
            "value": "71.060.01",
            "label": "71.060.01 无机化学综合",

          },
          {
            "value": "71.060.10",
            "label": "71.060.10 化学元素",

          },
          {
            "value": "71.060.20",
            "label": "71.060.20 氧化物",

          },
          {
            "value": "71.060.30",
            "label": "71.060.30 酸",

          },
          {
            "value": "71.060.40",
            "label": "71.060.40 碱",

          },
          {
            "value": "71.060.50",
            "label": "71.060.50 盐",

          },
          {
            "value": "71.060.99",
            "label": "71.060.99 其他无机化学品",

          }
        ]
      },
      {
        "value": "71.080",
        "label": "71.080 有机化学",
        "children": [
          {
            "value": "71.080.01",
            "label": "71.080.01 有机化学综合",

          },
          {
            "value": "71.080.10",
            "label": "71.080.10 脂族烃",

          },
          {
            "value": "71.080.15",
            "label": "71.080.15 芳香烃",

          },
          {
            "value": "71.080.20",
            "label": "71.080.20 卤代烃",

          },
          {
            "value": "71.080.30",
            "label": "71.080.30 有机氮化物",

          },
          {
            "value": "71.080.40",
            "label": "71.080.40 有机酸",

          },
          {
            "value": "71.080.50",
            "label": "71.080.50 酐",

          },
          {
            "value": "71.080.60",
            "label": "71.080.60 醇、醚",

          },
          {
            "value": "71.080.70",
            "label": "71.080.70 脂类",

          },
          {
            "value": "71.080.80",
            "label": "71.080.80 醛和酮",

          },
          {
            "value": "71.080.90",
            "label": "71.080.90 酚",

          },
          {
            "value": "71.080.99",
            "label": "71.080.99 其他有机化学品",

          }
        ]
      },
      {
        "value": "71.100",
        "label": "71.100 化工产品",
        "children": [
          {
            "value": "71.100.01",
            "label": "71.100.01 化工产品综合",

          },
          {
            "value": "71.100.10",
            "label": "71.100.10 铝生产用材料",

          },
          {
            "value": "71.100.20",
            "label": "71.100.20 工业气体",

          },
          {
            "value": "71.100.30",
            "label": "71.100.30 爆炸物、焰火",

          },
          {
            "value": "71.100.35",
            "label": "71.100.35 工业和家庭消毒用化学品",

          },
          {
            "value": "71.100.40",
            "label": "71.100.40 表面活性剂及其他助剂",

          },
          {
            "value": "71.100.45",
            "label": "71.100.45 制冷剂和防冻液",

          },
          {
            "value": "71.100.50",
            "label": "71.100.50 木材防护化学药品",

          },
          {
            "value": "71.100.55",
            "label": "71.100.55 硅树脂",

          },
          {
            "value": "71.100.60",
            "label": "71.100.60 香精油",

          },
          {
            "value": "71.100.70",
            "label": "71.100.70 美容品、化妆品",

          },
          {
            "value": "71.100.80",
            "label": "71.100.80 水处理剂",

          },
          {
            "value": "71.100.99",
            "label": "71.100.99 其他化工产品",

          }
        ]
      },
      {
        "value": "71.120",
        "label": "71.120 化工设备",
        "children": [
          {
            "value": "71.120.01",
            "label": "71.120.01 化工设备综合",

          },
          {
            "value": "71.120.10",
            "label": "71.120.10 反应容器及其组件",

          },
          {
            "value": "71.120.20",
            "label": "71.120.20 蒸馏塔",

          },
          {
            "value": "71.120.30",
            "label": "71.120.30 热交换器",

          },
          {
            "value": "71.120.99",
            "label": "71.120.99 其他化工设备",

          }
        ]
      }
    ]
  },
  {
    "value": "71-010",
    "label": "71-010 化工技术综合",

  },
  {
    "value": "73",
    "label": "73 采矿和矿产品",

  },
  {
    "value": "73-010",
    "label": "73-010 采矿和矿产品综合",
    "children": [
      {
        "value": "73.020",
        "label": "73.020 采矿和挖掘",

      },
      {
        "value": "73.040",
        "label": "73.040 煤",

      },
      {
        "value": "73.060",
        "label": "73.060 金属矿",
        "children": [
          {
            "value": "73.060.01",
            "label": "73.060.01 金属矿综合",

          },
          {
            "value": "73.060.10",
            "label": "73.060.10 铁矿",

          },
          {
            "value": "73.060.20",
            "label": "73.060.20 锰矿",

          },
          {
            "value": "73.060.30",
            "label": "73.060.30 铬矿",

          },
          {
            "value": "73.060.40",
            "label": "73.060.40 铝矿",

          },
          {
            "value": "73.060.99",
            "label": "73.060.99 其他金属矿",

          }
        ]
      },
      {
        "value": "73.080",
        "label": "73.080 非金属矿",

      },
      {
        "value": "73.100",
        "label": "73.100 采矿设备",
        "children": [
          {
            "value": "73.100.01",
            "label": "73.100.01 采矿设备综合",

          },
          {
            "value": "73.100.10",
            "label": "73.100.10 巷道掘进和敷设管道设备",

          },
          {
            "value": "73.100.20",
            "label": "73.100.20 通风、空调和照明设备",

          },
          {
            "value": "73.100.30",
            "label": "73.100.30 钻井和挖掘设备",

          },
          {
            "value": "73.100.40",
            "label": "73.100.40 牵引和起重设备",

          },
          {
            "value": "73.100.99",
            "label": "73.100.99 其他采矿设备",

          }
        ]
      },
      {
        "value": "73.120",
        "label": "73.120 矿产加工设备",

      }
    ]
  },
  {
    "value": "75",
    "label": "75 石油及相关技术",
    "children": [
      {
        "value": "75.020",
        "label": "75.020 石油和天然气的开采与加工",

      },
      {
        "value": "75.040",
        "label": "75.040 原油",

      },
      {
        "value": "75.060",
        "label": "75.060 天然气",

      },
      {
        "value": "75.080",
        "label": "75.080 石油产品综合",

      },
      {
        "value": "75.100",
        "label": "75.100 润滑剂、工业油及相关产品",

      },
      {
        "value": "75.120",
        "label": "75.120 液压液",

      },
      {
        "value": "75.140",
        "label": "75.140 石蜡、沥青材料和其他石油产品",

      },
      {
        "value": "75.160",
        "label": "75.160 燃料",
        "children": [
          {
            "value": "75.160.01",
            "label": "75.160.01 燃料综合",

          },
          {
            "value": "75.160.10",
            "label": "75.160.10 固体燃料",

          },
          {
            "value": "75.160.20",
            "label": "75.160.20 液体燃料",

          },
          {
            "value": "75.160.30",
            "label": "75.160.30 气体燃料",

          }
        ]
      },
      {
        "value": "75.180",
        "label": "75.180 石油和天然气工业设备",
        "children": [
          {
            "value": "75.180.01",
            "label": "75.180.01 石油和天然气工业设备综合",

          },
          {
            "value": "75.180.10",
            "label": "75.180.10 勘探和钻采设备",

          },
          {
            "value": "75.180.20",
            "label": "75.180.20 加工设备",

          },
          {
            "value": "75.180.30",
            "label": "75.180.30 容积设备和容积测量",

          },
          {
            "value": "75.180.99",
            "label": "75.180.99 其他石油和天然气工业设备",

          }
        ]
      },
      {
        "value": "75.200",
        "label": "75.200 石油、石油产品和天然气储运设备",

      }
    ]
  },
  {
    "value": "75-010",
    "label": "75-010 石油及相关技术综合",

  },
  {
    "value": "77",
    "label": "77 冶金",
    "children": [
      {
        "value": "77.020",
        "label": "77.020 金属生产",

      },
      {
        "value": "77.040",
        "label": "77.040 金属材料试验",
        "children": [
          {
            "value": "77.040.01",
            "label": "77.040.01 金属材料试验综合",

          },
          {
            "value": "77.040.10",
            "label": "77.040.10 金属材料机械试验",

          },
          {
            "value": "77.040.20",
            "label": "77.040.20 金属材料无损检测",

          },
          {
            "value": "77.040.30",
            "label": "77.040.30 金属材料化学分析",

          },
          {
            "value": "77.040.99",
            "label": "77.040.99 金属材料的其他试验方法",

          }
        ]
      },
      {
        "value": "77.060",
        "label": "77.060 金属的腐蚀",

      },
      {
        "value": "77.080",
        "label": "77.080 黑色金属",
        "children": [
          {
            "value": "77.080.01",
            "label": "77.080.01 黑色金属综合",

          },
          {
            "value": "77.080.10",
            "label": "77.080.10 铁",

          },
          {
            "value": "77.080.20",
            "label": "77.080.20 钢",

          }
        ]
      },
      {
        "value": "77.100",
        "label": "77.100 铁合金",

      },
      {
        "value": "77.120",
        "label": "77.120 有色金属",
        "children": [
          {
            "value": "77.120.01",
            "label": "77.120.01 有色金属综合",

          },
          {
            "value": "77.120.10",
            "label": "77.120.10 铝和铝合金",

          },
          {
            "value": "77.120.20",
            "label": "77.120.20 镁和镁合金",

          },
          {
            "value": "77.120.30",
            "label": "77.120.30 铜和铜合金",

          },
          {
            "value": "77.120.40",
            "label": "77.120.40 镍、铬及其合金",

          },
          {
            "value": "77.120.50",
            "label": "77.120.50 钛和钛合金",

          },
          {
            "value": "77.120.60",
            "label": "77.120.60 铅、锌、锡及其合金",

          },
          {
            "value": "77.120.70",
            "label": "77.120.70 镉、钴及其合金",

          },
          {
            "value": "77.120.99",
            "label": "77.120.99 其他有色金属及其合金",

          }
        ]
      },
      {
        "value": "77.140",
        "label": "77.140 钢铁产品",
        "children": [
          {
            "value": "77.140.01",
            "label": "77.140.01 钢铁产品综合",

          },
          {
            "value": "77.140.10",
            "label": "77.140.10 热处理钢",

          },
          {
            "value": "77.140.15",
            "label": "77.140.15 混凝土增强用钢",

          },
          {
            "value": "77.140.20",
            "label": "77.140.20 不锈钢",

          },
          {
            "value": "77.140.25",
            "label": "77.140.25 弹簧钢",

          },
          {
            "value": "77.140.30",
            "label": "77.140.30 承压钢",

          },
          {
            "value": "77.140.35",
            "label": "77.140.35 工具钢",

          },
          {
            "value": "77.140.40",
            "label": "77.140.40 特殊磁性钢",

          },
          {
            "value": "77.140.45",
            "label": "77.140.45 非合金钢",

          },
          {
            "value": "77.140.50",
            "label": "77.140.50 扁平钢和半成品",

          },
          {
            "value": "77.140.60",
            "label": "77.140.60 钢棒和条钢",

          },
          {
            "value": "77.140.65",
            "label": "77.140.65 钢丝、钢丝绳和环节链",

          },
          {
            "value": "77.140.70",
            "label": "77.140.70 型钢",

          },
          {
            "value": "77.140.75",
            "label": "77.140.75 特殊用管钢",

          },
          {
            "value": "77.140.80",
            "label": "77.140.80 钢铁铸件",

          },
          {
            "value": "77.140.85",
            "label": "77.140.85 钢铁锻件",

          },
          {
            "value": "77.140.99",
            "label": "77.140.99 其他钢铁产品",

          }
        ]
      },
      {
        "value": "77.150",
        "label": "77.150 有色金属产品",
        "children": [
          {
            "value": "77.150.01",
            "label": "77.150.01 有色金属产品综合",

          },
          {
            "value": "77.150.10",
            "label": "77.150.10 铝产品",

          },
          {
            "value": "77.150.20",
            "label": "77.150.20 锰产品",

          },
          {
            "value": "77.150.30",
            "label": "77.150.30 铜产品",

          },
          {
            "value": "77.150.40",
            "label": "77.150.40 镍和铬产品",

          },
          {
            "value": "77.150.50",
            "label": "77.150.50 钛产品",

          },
          {
            "value": "77.150.60",
            "label": "77.150.60 铅、锌和锡产品",

          },
          {
            "value": "77.150.70",
            "label": "77.150.70 镉和钴产品",

          },
          {
            "value": "77.150.99",
            "label": "77.150.99 其他有色金属产品",

          }
        ]
      },
      {
        "value": "77.160",
        "label": "77.160 粉末冶金",

      },
      {
        "value": "77.180",
        "label": "77.180 冶金设备",

      }
    ]
  },
  {
    "value": "77-010",
    "label": "77-010 冶金综合",

  },
  {
    "value": "79",
    "label": "79 木材技术",
    "children": [
      {
        "value": "79.020",
        "label": "79.020 木材加工技术",

      },
      {
        "value": "79.040",
        "label": "79.040 木材、原木和锯材",

      },
      {
        "value": "79.060",
        "label": "79.060 木基板材",
        "children": [
          {
            "value": "79.060.01",
            "label": "79.060.01 木基板材综合",

          },
          {
            "value": "79.060.10",
            "label": "79.060.10 胶合板",

          },
          {
            "value": "79.060.20",
            "label": "79.060.20 纤维和刨花板",

          },
          {
            "value": "79.060.99",
            "label": "79.060.99 其他木基板材",

          }
        ]
      },
      {
        "value": "79.080",
        "label": "79.080 半成品材",

      },
      {
        "value": "79.100",
        "label": "79.100 软木和软木制品",

      },
      {
        "value": "79.120",
        "label": "79.120 木工设备",
        "children": [
          {
            "value": "79.120.01",
            "label": "79.120.01 木工设备综合",

          },
          {
            "value": "79.120.10",
            "label": "79.120.10 木工机械",

          },
          {
            "value": "79.120.20",
            "label": "79.120.20 木工工具",

          },
          {
            "value": "79.120.99",
            "label": "79.120.99 其他木工设备",

          }
        ]
      }
    ]
  },
  {
    "value": "79-010",
    "label": "79-010 木材技术综合",

  },
  {
    "value": "81",
    "label": "81 玻璃和陶瓷工业",
    "children": [
      {
        "value": "81.020",
        "label": "81.020 玻璃和陶瓷生产工艺",

      },
      {
        "value": "81.040",
        "label": "81.040 玻璃",
        "children": [
          {
            "value": "81.040.01",
            "label": "81.040.01 玻璃综合",

          },
          {
            "value": "81.040.10",
            "label": "81.040.10 原材料和未加工的玻璃",

          },
          {
            "value": "81.040.20",
            "label": "81.040.20 建筑玻璃",

          },
          {
            "value": "81.040.30",
            "label": "81.040.30 玻璃产品",

          }
        ]
      },
      {
        "value": "81.060",
        "label": "81.060 陶瓷",
        "children": [
          {
            "value": "81.060.01",
            "label": "81.060.01 陶瓷综合",

          },
          {
            "value": "81.060.10",
            "label": "81.060.10 原料",

          },
          {
            "value": "81.060.20",
            "label": "81.060.20 陶瓷制品",

          },
          {
            "value": "81.060.30",
            "label": "81.060.30 高级陶瓷",

          },
          {
            "value": "81.060.99",
            "label": "81.060.99 有关陶瓷的其他标准",

          }
        ]
      },
      {
        "value": "81.080",
        "label": "81.080 耐火材料",

      },
      {
        "value": "81.100",
        "label": "81.100 玻璃和陶瓷生产设备",

      }
    ]
  },
  {
    "value": "83",
    "label": "83 橡胶和塑料工业",
    "children": [
      {
        "value": "83.020",
        "label": "83.020 橡胶和塑料工业的生产工艺",

      },
      {
        "value": "83.040",
        "label": "83.040 橡胶和塑料用原料",
        "children": [
          {
            "value": "83.040.01",
            "label": "83.040.01 橡胶和塑料用原料综合",

          },
          {
            "value": "83.040.10",
            "label": "83.040.10 胶乳和生橡胶",

          },
          {
            "value": "83.040.20",
            "label": "83.040.20 橡胶合成配料",

          },
          {
            "value": "83.040.30",
            "label": "83.040.30 塑料的辅料和添加剂",

          }
        ]
      },
      {
        "value": "83.060",
        "label": "83.060 橡胶",

      },
      {
        "value": "83.080",
        "label": "83.080 塑料",
        "children": [
          {
            "value": "83.080.01",
            "label": "83.080.01 塑料综合",

          },
          {
            "value": "83.080.10",
            "label": "83.080.10 热固性塑料",

          },
          {
            "value": "83.080.20",
            "label": "83.080.20 热塑性塑料",

          }
        ]
      },
      {
        "value": "83.100",
        "label": "83.100 泡沫材料",

      },
      {
        "value": "83.120",
        "label": "83.120 增强塑料",

      },
      {
        "value": "83.140",
        "label": "83.140 橡胶和塑料制品",
        "children": [
          {
            "value": "83.140.01",
            "label": "83.140.01 橡胶和塑料制品综合",

          },
          {
            "value": "83.140.10",
            "label": "83.140.10 薄膜和薄板",

          },
          {
            "value": "83.140.20",
            "label": "83.140.20 层压薄板",

          },
          {
            "value": "83.140.30",
            "label": "83.140.30 塑料管、配件和阀门",

          },
          {
            "value": "83.140.40",
            "label": "83.140.40 软管",

          },
          {
            "value": "83.140.50",
            "label": "83.140.50 密封件",

          },
          {
            "value": "83.140.99",
            "label": "83.140.99 其他橡胶和塑料制品",

          }
        ]
      },
      {
        "value": "83.160",
        "label": "83.160 轮胎",
        "children": [
          {
            "value": "83.160.01",
            "label": "83.160.01 轮胎综合",

          },
          {
            "value": "83.160.10",
            "label": "83.160.10 道路车辆轮胎",

          },
          {
            "value": "83.160.20",
            "label": "83.160.20 航空器轮胎",

          },
          {
            "value": "83.160.30",
            "label": "83.160.30 农业机械用轮胎",

          },
          {
            "value": "83.160.99",
            "label": "83.160.99 其他轮胎",

          }
        ]
      },
      {
        "value": "83.180",
        "label": "83.180 粘合剂和胶粘产品",

      },
      {
        "value": "83.200",
        "label": "83.200 橡胶和塑料工业设备",

      }
    ]
  },
  {
    "value": "85",
    "label": "85 造纸技术",
    "children": [
      {
        "value": "85.020",
        "label": "85.020 纸生产工艺",

      },
      {
        "value": "85.040",
        "label": "85.040 纸浆",

      },
      {
        "value": "85.060",
        "label": "85.060 纸和纸板",

      },
      {
        "value": "85.080",
        "label": "85.080 纸制品",

      },
      {
        "value": "85.100",
        "label": "85.100 造纸工业设备",

      }
    ]
  },
  {
    "value": "85-010",
    "label": "85-010 造纸技术综合",

  },
  {
    "value": "87",
    "label": "87 涂料和颜料工业",
    "children": [
      {
        "value": "87.020",
        "label": "87.020 涂料涂覆工艺",

      },
      {
        "value": "87.040",
        "label": "87.040 涂料和清漆",

      },
      {
        "value": "87.060",
        "label": "87.060 涂料配料",
        "children": [
          {
            "value": "87.060.01",
            "label": "87.060.01 涂料配料综合",

          },
          {
            "value": "87.060.10",
            "label": "87.060.10 颜料和填充剂",

          },
          {
            "value": "87.060.20",
            "label": "87.060.20 涂料粘合剂",

          },
          {
            "value": "87.060.30",
            "label": "87.060.30 溶剂",

          },
          {
            "value": "87.060.99",
            "label": "87.060.99 其他涂料配料",

          }
        ]
      },
      {
        "value": "87.080",
        "label": "87.080 墨水、油墨",

      },
      {
        "value": "87.100",
        "label": "87.100 涂料涂覆设备",

      }
    ]
  },
  {
    "value": "87-010",
    "label": "87-010 涂料和颜料工业综合",

  },
  {
    "value": "91",
    "label": "91 建筑材料和建筑物",
    "children": [
      {
        "value": "91.010",
        "label": "91.010 建筑工业",
        "children": [
          {
            "value": "91.010.01",
            "label": "91.010.01 建筑工业综合",

          },
          {
            "value": "91.010.10",
            "label": "91.010.10 法律方面",

          },
          {
            "value": "91.010.20",
            "label": "91.010.20 合同方面",

          },
          {
            "value": "91.010.30",
            "label": "91.010.30 技术方面",

          },
          {
            "value": "91.010.99",
            "label": "91.010.99 其他方面",

          }
        ]
      },
      {
        "value": "91.020",
        "label": "91.020 自然规划、城市规划",

      },
      {
        "value": "91.040",
        "label": "91.040 建筑物",
        "children": [
          {
            "value": "91.040.01",
            "label": "91.040.01 建筑物综合",

          },
          {
            "value": "91.040.10",
            "label": "91.040.10 公共建筑物",

          },
          {
            "value": "91.040.20",
            "label": "91.040.20 商业和工业建筑物",

          },
          {
            "value": "91.040.30",
            "label": "91.040.30 住宅建筑物",

          },
          {
            "value": "91.040.99",
            "label": "91.040.99 其他建筑物",

          }
        ]
      },
      {
        "value": "91.060",
        "label": "91.060 建筑构件",
        "children": [
          {
            "value": "91.060.01",
            "label": "91.060.01 建筑构件综合",

          },
          {
            "value": "91.060.10",
            "label": "91.060.10 墙、隔墙、面墙",

          },
          {
            "value": "91.060.20",
            "label": "91.060.20 屋顶",

          },
          {
            "value": "91.060.30",
            "label": "91.060.30 天花板、地板、楼梯",

          },
          {
            "value": "91.060.40",
            "label": "91.060.40 烟囱、竖井、通风道",

          },
          {
            "value": "91.060.50",
            "label": "91.060.50 门窗",

          },
          {
            "value": "91.060.99",
            "label": "91.060.99 建筑物的其他构件",

          }
        ]
      },
      {
        "value": "91.080",
        "label": "91.080 建筑物结构",
        "children": [
          {
            "value": "91.080.01",
            "label": "91.080.01 建筑结构综合",

          },
          {
            "value": "91.080.10",
            "label": "91.080.10 金属结构",

          },
          {
            "value": "91.080.20",
            "label": "91.080.20 木结构",

          },
          {
            "value": "91.080.30",
            "label": "91.080.30 砖石结构",

          },
          {
            "value": "91.080.40",
            "label": "91.080.40 混凝土结构",

          },
          {
            "value": "91.080.99",
            "label": "91.080.99 其他结构",

          }
        ]
      },
      {
        "value": "91.090",
        "label": "91.090 外围建筑物",

      },
      {
        "value": "91.100",
        "label": "91.100 建筑材料",
        "children": [
          {
            "value": "91.100.01",
            "label": "91.100.01 建筑材料综合",

          },
          {
            "value": "91.100.10",
            "label": "91.100.10 水泥、石膏、石灰、砂浆",

          },
          {
            "value": "91.100.15",
            "label": "91.100.15 矿物材料和产品",

          },
          {
            "value": "91.100.25",
            "label": "91.100.25 陶瓷和陶砖瓦建筑制品",

          },
          {
            "value": "91.100.30",
            "label": "91.100.30 混凝土和混凝土制品",

          },
          {
            "value": "91.100.40",
            "label": "91.100.40 纤维增强水泥制品",

          },
          {
            "value": "91.100.50",
            "label": "91.100.50 粘合料、密封材料",

          },
          {
            "value": "91.100.60",
            "label": "91.100.60 隔声和绝热材料",

          },
          {
            "value": "91.100.99",
            "label": "91.100.99 其他建筑材料",

          }
        ]
      },
      {
        "value": "91.120",
        "label": "91.120 建筑物的防护",
        "children": [
          {
            "value": "91.120.01",
            "label": "91.120.01 建筑物的防护综合",

          },
          {
            "value": "91.120.10",
            "label": "91.120.10 建筑物绝热",

          },
          {
            "value": "91.120.20",
            "label": "91.120.20 建筑物声学、隔音",

          },
          {
            "value": "91.120.25",
            "label": "91.120.25 地震和防振",

          },
          {
            "value": "91.120.30",
            "label": "91.120.30 防水",

          },
          {
            "value": "91.120.40",
            "label": "91.120.40 雷电防护",

          },
          {
            "value": "91.120.99",
            "label": "91.120.99 有关建筑物防护的其他标准",

          }
        ]
      },
      {
        "value": "91.140",
        "label": "91.140 建筑物中的设施",
        "children": [
          {
            "value": "91.140.01",
            "label": "91.140.01 建筑物中的设施综合",

          },
          {
            "value": "91.140.10",
            "label": "91.140.10 中央供热系统",

          },
          {
            "value": "91.140.30",
            "label": "91.140.30 通风和空调",

          },
          {
            "value": "91.140.40",
            "label": "91.140.40 供气系统",

          },
          {
            "value": "91.140.50",
            "label": "91.140.50 供电系统",

          },
          {
            "value": "91.140.60",
            "label": "91.140.60 供水系统",

          },
          {
            "value": "91.140.65",
            "label": "91.140.65 水加热设备",

          },
          {
            "value": "91.140.70",
            "label": "91.140.70 卫生设备",

          },
          {
            "value": "91.140.80",
            "label": "91.140.80 排水系统",

          },
          {
            "value": "91.140.90",
            "label": "91.140.90 电梯、自动扶梯",

          },
          {
            "value": "91.140.99",
            "label": "91.140.99 建筑物中的其他设施",

          }
        ]
      },
      {
        "value": "91.160",
        "label": "91.160 照明",
        "children": [
          {
            "value": "91.160.01",
            "label": "91.160.01 照明综合",

          },
          {
            "value": "91.160.10",
            "label": "91.160.10 室内照明",

          },
          {
            "value": "91.160.20",
            "label": "91.160.20 室外照明",

          }
        ]
      },
      {
        "value": "91.180",
        "label": "91.180 内部装修",

      },
      {
        "value": "91.190",
        "label": "91.190 建筑附件",

      },
      {
        "value": "91.200",
        "label": "91.200 施工技术",

      },
      {
        "value": "91.220",
        "label": "91.220 施工设备",

      }
    ]
  },
  {
    "value": "91-110",
    "label": "91-110 建材设备",

  },
  {
    "value": "93",
    "label": "93 土木工程",
    "children": [
      {
        "value": "93.010",
        "label": "93.010 土木工程综合",

      },
      {
        "value": "93.020",
        "label": "93.020 土方工程、挖掘、地基构造、地下工程",

      },
      {
        "value": "93.025",
        "label": "93.025 外部输水系统",

      },
      {
        "value": "93.030",
        "label": "93.030 外部污水排放系统",

      },
      {
        "value": "93.040",
        "label": "93.040 桥梁建筑",

      },
      {
        "value": "93.060",
        "label": "93.060 隧道建筑",

      },
      {
        "value": "93.080",
        "label": "93.080 道路工程",
        "children": [
          {
            "value": "93.080.01",
            "label": "93.080.01 道路工程综合",

          },
          {
            "value": "93.080.10",
            "label": "93.080.10 道路建筑",

          },
          {
            "value": "93.080.20",
            "label": "93.080.20 道路建筑材料",

          },
          {
            "value": "93.080.30",
            "label": "93.080.30 道路设备和装置",

          },
          {
            "value": "93.080.40",
            "label": "93.080.40 街道照明和有关设备",

          },
          {
            "value": "93.080.99",
            "label": "93.080.99 有关道路工程的其他标准",

          }
        ]
      },
      {
        "value": "93.100",
        "label": "93.100 铁路建筑",

      },
      {
        "value": "93.110",
        "label": "93.110 索道建造",

      },
      {
        "value": "93.120",
        "label": "93.120 飞机场建筑",

      },
      {
        "value": "93.140",
        "label": "93.140 航道和港口建筑",

      },
      {
        "value": "93.160",
        "label": "93.160 水利建筑",

      }
    ]
  },
  {
    "value": "95",
    "label": "95 军事工程",
    "children": [
      {
        "value": "95.020",
        "label": "95.020 军事工程、军事物资、武器",

      }
    ]
  },
  {
    "value": "97",
    "label": "97 家用和商用设备、文娱、体育",
    "children": [
      {
        "value": "97.020",
        "label": "97.020 家政",

      },
      {
        "value": "97.030",
        "label": "97.030 家用电气设备综合",

      },
      {
        "value": "97.040",
        "label": "97.040 厨房设备",
        "children": [
          {
            "value": "97.040.01",
            "label": "97.040.01 厨房设备综合",

          },
          {
            "value": "97.040.10",
            "label": "97.040.10 厨房家具",

          },
          {
            "value": "97.040.20",
            "label": "97.040.20 炉灶、工作台、烤箱和类似器具",

          },
          {
            "value": "97.040.30",
            "label": "97.040.30 家用制冷设备",

          },
          {
            "value": "97.040.40",
            "label": "97.040.40 洗碗机",

          },
          {
            "value": "97.040.50",
            "label": "97.040.50 厨房小器具",

          },
          {
            "value": "97.040.60",
            "label": "97.040.60 烹调用器皿、刀具和餐具",

          },
          {
            "value": "97.040.99",
            "label": "97.040.99 其他厨房设备",

          }
        ]
      },
      {
        "value": "97.060",
        "label": "97.060 洗衣设备",

      },
      {
        "value": "97.080",
        "label": "97.080 地板处理设备",

      },
      {
        "value": "97.100",
        "label": "97.100 家用、商用和工业用加热器具",
        "children": [
          {
            "value": "97.100.01",
            "label": "97.100.01 加热器具综合",

          },
          {
            "value": "97.100.10",
            "label": "97.100.10 电加热器",

          },
          {
            "value": "97.100.20",
            "label": "97.100.20 气体加热器",

          },
          {
            "value": "97.100.30",
            "label": "97.100.30 固体燃料加热器",

          },
          {
            "value": "97.100.40",
            "label": "97.100.40 液体燃料加热器",

          },
          {
            "value": "97.100.99",
            "label": "97.100.99 使用其他能源的加热器",

          }
        ]
      },
      {
        "value": "97.120",
        "label": "97.120 家用自动控制装置",

      },
      {
        "value": "97.130",
        "label": "97.130 商店设施",
        "children": [
          {
            "value": "97.130.01",
            "label": "97.130.01 商店设施综合",

          },
          {
            "value": "97.130.10",
            "label": "97.130.10 搁板",

          },
          {
            "value": "97.130.20",
            "label": "97.130.20 商用制冷设备",

          },
          {
            "value": "97.130.30",
            "label": "97.130.30 超级市场用手推车",

          },
          {
            "value": "97.130.99",
            "label": "97.130.99 其他商店设施",

          }
        ]
      },
      {
        "value": "97.140",
        "label": "97.140 家具",

      },
      {
        "value": "97.145",
        "label": "97.145 梯子",

      },
      {
        "value": "97.150",
        "label": "97.150 铺地非织物",

      },
      {
        "value": "97.160",
        "label": "97.160 家用织物、亚麻织物",

      },
      {
        "value": "97.170",
        "label": "97.170 人体保健器具",

      },
      {
        "value": "97.180",
        "label": "97.180 其他家用和商用设备",

      },
      {
        "value": "97.190",
        "label": "97.190 儿童用器具",

      },
      {
        "value": "97.195",
        "label": "97.195 艺术和手工艺品",

      },
      {
        "value": "97.200",
        "label": "97.200 文娱活动设备",
        "children": [
          {
            "value": "97.200.01",
            "label": "97.200.01 文娱活动设备综合",

          },
          {
            "value": "97.200.10",
            "label": "97.200.10 剧院、舞台和演播室设备",

          },
          {
            "value": "97.200.20",
            "label": "97.200.20 乐器",

          },
          {
            "value": "97.200.30",
            "label": "97.200.30 野营设备和营地",

          },
          {
            "value": "97.200.40",
            "label": "97.200.40 游乐场",

          },
          {
            "value": "97.200.50",
            "label": "97.200.50 玩具",

          },
          {
            "value": "97.200.99",
            "label": "97.200.99 其他文娱活动设备",

          }
        ]
      },
      {
        "value": "97.220",
        "label": "97.220 运动设备和设施",
        "children": [
          {
            "value": "97.220.01",
            "label": "97.220.01 运动设备和设施综合",

          },
          {
            "value": "97.220.10",
            "label": "97.220.10 运动设施",

          },
          {
            "value": "97.220.20",
            "label": "97.220.20 冬季运动设备",

          },
          {
            "value": "97.220.30",
            "label": "97.220.30 室内运动设备",

          },
          {
            "value": "97.220.40",
            "label": "97.220.40 室外和水上运动设备",

          },
          {
            "value": "97.220.99",
            "label": "97.220.99 其他运动设备和设施",

          }
        ]
      }
    ]
  }
]


export default {
  groupData
}